<template>
  <div>
    <page-header
      left-side-class="col-12 col-md-7"
      :page="headerConfig"
      right-side-class="col-12 col-md-5"
    >
      <template #customActions>
        <action-button
          id="billing-history-management-button-back"
          class="mr-2"
          i="fas fa-arrow-circle-left fa-fw"
          text="Regresar"
          variant="outline-success"
          @click="navigateBack"
        />
        <div v-if="showDeterminationActions">
          <drop-down
            class="ml-2 w-sm-100 dropdown-custom-action"
            icon="fas fa-flag"
            :items="requestDeterminationActionItems"
            title="Determinar"
          />
        </div>
        <action-button
          v-if="canSubmit"
          class="px-3 ml-2"
          i="fas fa-flag pr-0"
          text="Someter"
          variant="success"
          @click="onSubmitHandler()"
        />
        <action-button
          v-if="!existBiddingRequest && !isLockRestricted"
          class="px-3 ml-2"
          i="fas fa-save pr-0"
          text="Guardar"
          variant="success"
          @click="onSaveBiddingHandler()"
        />
        <action-button
          v-if="canLock"
          class="px-3 ml-2"
          i="fas fa-lock pr-0"
          text="Bloquear"
          variant="warning"
          @click="onLockHandler()"
        />
        <action-button
          v-if="isLockedByCurrentUser"
          class="px-3 ml-2"
          i="fas fa-lock-open pr-0"
          text="Desbloquear"
          variant="outline-warning"
          @click="onUnlockHandler()"
        />
      </template>
    </page-header>

    <bidding-request-determination
      v-if="isOpenRequestDetermination"
      :academic-year-id="academicYearId"
      class="mb-3"
      :company-id="companyId"
      :contracts-documents="this.documents"
      :status-id="requestDeterminationStatusId"
      @on-cancel="onCancelRequestDeterminationHandler"
      @on-saved="onSavedRequestDeterminationHandler"
    />
    <provider-header-info
      v-model="providerInfo"
      :can-edit="false"
      class="mb-4"
      :provider-id="companyId"
      :show-primary-contact-information="true"
      @toggle-ssn-mask="onToggleSSNMaskHandler($event)"
    />
    <div>
      <section-title
        container-class="tag-badge-main-info m-0 mb-3"
        content="Información General de la Solicitud"
        icon="fas fa-ballot-check"
      />
      <validation-observer ref="biddingFormRef" v-slot="{}" tag="form">
        <div class="row mx-3">
          <div class="col-md-3 col-sm-12 mt-3 mt-md-0">
            <div class="color-gray-6 font-14 mb-1">Año Fiscal:</div>
            <validation-provider
              v-if="!isBiddingRequestPending"
              v-slot="{ errors }"
              rules="required"
            >
              <custom-drop-down
                v-model="model.academicYear"
                :clearable="false"
                custom-error-msg="El año fiscal es requerido."
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                :options="academicYears"
                placeholder="Seleccione"
              />
            </validation-provider>
            <span v-else class="data-content">
              {{ biddingAcademicYearName }}
            </span>
          </div>
          <div
            v-if="existBiddingRequest"
            class="col-md-3 col-sm-12 mt-3 mt-md-0"
          >
            <div class="color-gray-6 font-14 mb-1">Número de Solicitud:</div>
            <span class="data-content">{{ biddingRequestNumber }}</span>
          </div>
        </div>
      </validation-observer>
    </div>

    <div v-if="providerProfileEnabled">
      <section-title
        container-class="tag-badge-main-info m-0 mt-4 mb-3"
        content="Perfil del Proveedor"
        icon="fas fa-user-tie"
      />

      <!--Resumen Ejecutivo-->
      <custom-callout
        :border-color="getColorStatus(sectionInfoES.statusId)"
        class-main="mt-3 rounded"
        :controlled="true"
        :has-toggle="
          isPendingSQE(sectionInfoES.statusId) ||
            isSubmittedSQE(sectionInfoES.statusId) ||
            isApprovedSQE(sectionInfoES.statusId) ||
            isDeniedSQE(sectionInfoES.statusId)
        "
        :opened="
          isVisibleES || isVisibleES_DeniedPanel || isVisibleES_ApprovePanel
        "
        @click:open="onToggleCallOutES(sectionInfoES.statusId)"
      >
        <div class="row py-2 mr-md-0 align-items-center">
          <div
            class="col-md-2 d-flex justify-content-center align-items-center"
          >
            <custom-balloon
              :background-color="`bg-${getColorStatus(sectionInfoES.statusId)}`"
              class="w-md-90 w-60 m-0"
              :text="sectionInfoES.statusName"
            />
          </div>
          <div class="row divider col-md-9">
            <div
              class="col-sm-12 mt-3 mt-md-0"
              :class="
                isApprovedSQE(sectionInfoES.statusId) ||
                isDeniedSQE(sectionInfoES.statusId)
                  ? 'col-md-4'
                  : 'col-md-6'
              "
            >
              <div class="color-gray-6 font-14">
                Información del Perfil:
              </div>
              <div class="color-black font-16">
                {{ sectionInfoES.sectionName | empty }}
              </div>
            </div>
            <div
              v-if="
                sectionInfoES.submittedDate &&
                  (isSubmittedSQE(sectionInfoES.statusId) ||
                    isApprovedSQE(sectionInfoES.statusId) ||
                    isDeniedSQE(sectionInfoES.statusId))
              "
              class="col-sm-12 mt-3 mt-md-0 col-md-2"
            >
              <div class="color-gray-6 font-14">Fecha de Sometido:</div>
              <div class="color-black font-16">
                {{ sectionInfoES.submittedDate | date }}
              </div>
            </div>
            <div
              v-if="
                sectionInfoES.lastStatusSubmittedDate &&
                  isSubmittedSQE(sectionInfoES.statusId) &&
                  !isApprovedSQE(sectionInfoES.statusId)
              "
              class="col-sm-12 mt-3 mt-md-0 col-md-2"
            >
              <div class="color-gray-6 font-14">Fecha de Último Estatus:</div>
              <div class="color-black font-16">
                {{ sectionInfoES.lastStatusSubmittedDate | date }}
              </div>
            </div>
            <div
              v-if="
                sectionInfoES.determinationDate &&
                  (isApprovedSQE(sectionInfoES.statusId) ||
                    isDeniedSQE(sectionInfoES.statusId))
              "
              class="col-sm-12 mt-3 mt-md-0 col-md-2"
            >
              <div class="color-gray-6 font-14">Fecha de Determinación:</div>
              <div class="color-black font-16">
                {{ sectionInfoES.determinationDate | date }}
              </div>
            </div>
            <div
              v-if="
                isApprovedSQE(sectionInfoES.statusId) ||
                  isDeniedSQE(sectionInfoES.statusId)
              "
              class="col-sm-12 mt-3 mt-md-0 col-md-2"
            >
              <div class="color-gray-6 font-14">Determinado por:</div>
              <div class="color-black font-16">
                {{ sectionInfoES.determinationBy | empty }}
              </div>
            </div>
          </div>
          <div class="row col-md-1">
            <action-button
              v-if="canApproveDenySQE(sectionInfoES.statusId)"
              class="btn-action-size"
              i="fas fa-check pl-1"
              variant="success m-1 pl-1"
              @click="() => onShowApprovePanelHandlerES(sectionInfoES)"
            />
            <action-button
              v-if="canApproveDenySQE(sectionInfoES.statusId)"
              class="btn-action-size"
              i="fas fa-ban pl-1"
              variant="outline-danger m-1 pl-1"
              @click="() => onShowDeniedPanelHandlerES(sectionInfoES)"
            />
            <action-button
              v-if="canEditSQE(sectionInfoES.statusId)"
              class="btn-action-size"
              i="fas fa-edit pl-1"
              variant="outline-success m-1 pl-1"
              @click="() => onGoEditHandlerES(sectionInfoES)"
            />
            <action-button
              v-if="canGoBackSQE(sectionInfoES.statusId)"
              class="btn-action-size"
              i="fas fa-undo pl-1"
              variant="success m-1 pl-1"
              @click="() => onGoBackStatusHandlerSQE(sectionInfoES)"
            />
          </div>
        </div>
        <template #edition>
          <div>
            <!-- Denegar request panel -->
            <div
              v-if="isVisibleES_DeniedPanel || isVisibleES_ApprovePanel"
              class="m-2 col-md-12 rounded align-items-center"
            >
              <div class="rounded p-2">
                <icon-view
                  v-if="isVisibleES_DeniedPanel"
                  class="p-1 rounded-circle"
                  icon="fas fa-times-circle"
                  icon-color="#FF7058"
                  icon-size="14px"
                  title="Razón de Rechazo"
                  variant="custom-icon"
                />
                <icon-view
                  v-if="isVisibleES_ApprovePanel"
                  class="p-1 rounded-circle"
                  icon="fas fa-check-circle "
                  icon-color="#008000"
                  icon-size="14px"
                  title="Razón de Aprobación"
                  variant="custom-icon"
                />
                <div class="col-12 mt-3">
                  <label class="color-gray-6 font-14">
                    {{
                      isDeniedSQE(sectionInfoES.statusId)
                        ? 'Razón de Denegación:'
                        : 'Comentario:'
                    }}
                  </label>
                  <ValidationObserver ref="messageObserver_sectionInfoES">
                    <ValidationProvider v-slot="{ errors }" rules="required">
                      <span
                        v-if="
                          isDeniedSQE(sectionInfoES.statusId) &&
                            sectionInfoES.denialComment != null
                        "
                        class="data-content d-block text-justify"
                      >
                        {{ sectionInfoES.denialComment | empty }}
                      </span>
                      <custom-text-area
                        v-else
                        id="textAreaReasonsectionInfoES"
                        v-model="sectionInfoES.denialComment"
                        :count-classes="['float-right']"
                        custom-error-msg="El comentario es requerido."
                        :disabled="isDeniedSQE(sectionInfoES.statusId)"
                        :error="errors[0]"
                        :maxlength="3000"
                        :show-char-count="!isDeniedSQE(sectionInfoES.statusId)"
                      />
                    </ValidationProvider>
                  </ValidationObserver>
                </div>
              </div>
              <div
                v-if="!isDeniedSQE(sectionInfoES.statusId)"
                class="row mt-5 pb-4"
              >
                <div class="col-12">
                  <action-button
                    id="actionBtnSaveSectionInfoES"
                    class="float-right ml-2"
                    i="fas fa-save fa-lg"
                    text="Guardar"
                    variant="success"
                    @click="
                      () =>
                        onSaveES_Panel(
                          isVisibleES_DeniedPanel ? denied : approved
                        )
                    "
                  />
                  <action-button
                    id="actionBtnCancelSectionInfoES"
                    class="float-right"
                    i="fas fa-times-circle"
                    text="Cancelar"
                    variant="outline-danger"
                    @click="() => onCancelES_Panel()"
                  />
                </div>
              </div>
            </div>
            <!-- Denegar approved panel -->
          </div>
          <custom-tab class="custom-tabs">
            <custom-tab-item active lazy title="Resumen Ejecutivo">
              <div class="col-md-12 row pr-0">
                <div class="m-2 col-md-12 rounded">
                  <executive-summary
                    v-if="isVisibleES"
                    ref="ExecutiveSummary"
                    :bidding-academic-year-id="biddingAcademicYearId"
                    :provider-id="providerInfo?.companyId"
                    :questions="questionsES"
                    :section-title="sectionInfoES.sectionName"
                    :status-id="sectionInfoES.statusId"
                    @on-cancel="isVisibleES = false"
                    @on-save="getSectionsProviderProfile"
                  />
                </div>
              </div>
            </custom-tab-item>
            <custom-tab-item
              lazy
              title="Historial"
              @click="
                () => onTabClick(providerQuestionSection.ExecutiveSummary)
              "
            >
              <profile-section-history
                :items="sectionStatusHistoryMap.executiveSummary"
              />
            </custom-tab-item>
          </custom-tab>
        </template>
      </custom-callout>
      <!--Resumen Ejecutivo-->

      <!--Localidad-->
      <custom-callout
        v-if="sectionInfoLocation.statusName"
        :border-color="getColorStatus(sectionInfoLocation.statusId)"
        class-main="mt-3 rounded"
        :controlled="true"
        :has-toggle="true"
        :opened="
          isVisibleLocation ||
            isVisibleLocation_DeniedPanel ||
            isVisibleLocation_ConditionalApprovePanel ||
            isVisibleLocation_ReplacementPanel ||
            isVisibleLocation_ApprovePanel
        "
        :persist-data="true"
        @click:open="onToggleCallOutLocation(sectionInfoLocation.statusId)"
      >
        <div class="row py-2 mr-md-0 align-items-center">
          <div
            class="col-md-2 d-flex justify-content-center align-items-center"
          >
            <custom-balloon
              :background-color="
                `bg-${getColorStatus(sectionInfoLocation.statusId)}`
              "
              class="w-md-90 m-0"
              :class="
                isConditionalApprovedSQE(sectionInfoLocation.statusId) ||
                isReplacementRequestSQE(sectionInfoLocation.statusId)
                  ? 'w-70'
                  : 'w-60'
              "
              :text="sectionInfoLocation.statusName"
            />
          </div>
          <div class="row divider col-md-9">
            <div
              class="col-sm-12 mt-3 mt-md-0"
              :class="
                isApprovedSQE(sectionInfoLocation.statusId) ||
                isDeniedSQE(sectionInfoLocation.statusId)
                  ? 'col-md-4'
                  : 'col-md-6'
              "
            >
              <div class="color-gray-6 font-14">
                Información del Perfil:
              </div>
              <div class="color-black font-16">
                {{ sectionInfoLocation.sectionName | empty }}
              </div>
            </div>
            <div
              v-if="
                sectionInfoLocation.submittedDate &&
                  (isSubmittedSQE(sectionInfoLocation.statusId) ||
                    isApprovedSQE(sectionInfoLocation.statusId) ||
                    isDeniedSQE(sectionInfoLocation.statusId) ||
                    isReplacementRequestSQE(sectionInfoLocation.statusId))
              "
              class="col-sm-12 mt-3 mt-md-0 col-md-2"
            >
              <div class="color-gray-6 font-14">Fecha de Sometido:</div>
              <div class="color-black font-16">
                {{ sectionInfoLocation.submittedDate | date }}
              </div>
            </div>
            <div
              v-if="
                sectionInfoLocation.lastStatusSubmittedDate &&
                  isSubmittedSQE(sectionInfoLocation.statusId)
              "
              class="col-sm-12 mt-3 mt-md-0 col-md-2"
            >
              <div class="color-gray-6 font-14">Fecha de Último Estatus:</div>
              <div class="color-black font-16">
                {{ sectionInfoLocation.lastStatusSubmittedDate | date }}
              </div>
            </div>
            <div
              v-if="
                sectionInfoLocation.lastStatusSubmittedDate &&
                  (isApprovedSQE(sectionInfoLocation.statusId) ||
                    isDeniedSQE(sectionInfoLocation.statusId) ||
                    isConditionalApproved(sectionInfoLocation.statusId) ||
                    isReplacementRequestSQE(sectionInfoLocation.statusId))
              "
              class="col-sm-12 mt-3 mt-md-0 col-md-2"
            >
              <div class="color-gray-6 font-14">Fecha de Determinación:</div>
              <div class="color-black font-16">
                {{ sectionInfoLocation.determinationDate | date }}
              </div>
            </div>
            <div
              v-if="
                isApprovedSQE(sectionInfoLocation.statusId) ||
                  isDeniedSQE(sectionInfoLocation.statusId) ||
                  isConditionalApproved(sectionInfoLocation.statusId) ||
                  isReplacementRequestSQE(sectionInfoLocation.statusId)
              "
              class="col-sm-12 mt-3 mt-md-0 col-md-2"
            >
              <div class="color-gray-6 font-14">Determinado por:</div>
              <div class="color-black font-16">
                {{ sectionInfoLocation.determinationBy | empty }}
              </div>
            </div>
          </div>
          <div
            v-if="
              isApprovedSQE(sectionInfoLocation.statusId) ||
                isDeniedSQE(sectionInfoLocation.statusId) ||
                isConditionalApproved(sectionInfoLocation.statusId) ||
                isReplacementRequestSQE(sectionInfoLocation.statusId)
            "
            class="col-md-1 row"
          >
            <action-button
              v-if="canEditSQE(sectionInfoLocation.statusId)"
              class="btn-action-size"
              i="fas fa-edit pl-1"
              variant="outline-success m-1 pl-1"
              @click="() => onGoEditHandlerLocation(sectionInfoLocation)"
            />

            <action-button
              v-if="canReplacementRequestSQE(sectionInfoLocation.statusId)"
              class="btn-action-size"
              i="fas fa-arrow-from-right pl-1"
              variant="warning m-1 pl-1"
              @click="() => onShowReplacementRequestHandlerLocation()"
            />

            <action-button
              v-if="canGoBackSQE(sectionInfoLocation.statusId)"
              class="btn-action-size"
              i="fas fa-undo pl-1"
              variant="success m-1 pl-1"
              @click="() => onGoBackStatusHandlerSQE(sectionInfoLocation)"
            />
          </div>
          <div
            v-if="isSubmittedSQE(sectionInfoLocation.statusId)"
            class="col-md row"
          >
            <action-button
              v-if="canApproveDenySQE(sectionInfoLocation.statusId)"
              class="btn-action-size"
              i="fas fa-check pl-1"
              variant="success m-1 pl-1"
              @click="() => onShowApprovePanelHandlerLocation()"
            />

            <action-button
              v-if="canApproveDenySQE(sectionInfoLocation.statusId)"
              class="btn-action-size"
              i="fas fa-check pl-1"
              variant="outline-warning m-1 pl-1"
              @click="() => onShowConditionalApproveHandlerLocation()"
            />

            <action-button
              v-if="canApproveDenySQE(sectionInfoLocation.statusId)"
              class="btn-action-size"
              i="fas fa-ban pl-1"
              variant="outline-danger m-1 pl-1"
              @click="() => onShowDeniedPanelHandlerLocation()"
            />
          </div>
        </div>
        <div
          v-if="
            statusAlertLocation &&
              isUniquePermissionInProviderRequestDocumentsEnabled
          "
          class="row pb-2"
        >
          <div class="col-md-9 offset-md-2">
            <div class="color-gray-6 font-14">Comentario:</div>
            <div class="color-black font-16 text-justify">
              {{ statusAlertLocation }}
            </div>
          </div>
        </div>
        <template #edition>
          <div>
            <!-- Denegar request panel -->
            <div
              v-if="
                isVisibleLocation_DeniedPanel || isVisibleLocation_ApprovePanel
              "
              class="m-2 col-md-12 rounded align-items-center"
            >
              <div class="rounded p-2">
                <icon-view
                  v-if="isVisibleLocation_DeniedPanel"
                  class="p-1 rounded-circle"
                  icon="fas fa-times-circle"
                  icon-color="#FF7058"
                  icon-size="14px"
                  title="Razón de Rechazo"
                  variant="custom-icon"
                />
                <icon-view
                  v-if="isVisibleLocation_ApprovePanel"
                  class="p-1 rounded-circle"
                  icon="fas fa-check-circle"
                  icon-color="#008000"
                  icon-size="14px"
                  title="Razón de Aprobación"
                  variant="custom-icon"
                />

                <div class="col-12 mt-3">
                  <label class="color-gray-6 font-14">
                    {{
                      isDeniedSQE(sectionInfoLocation.statusId)
                        ? 'Razón de Denegación:'
                        : 'Comentario:'
                    }}
                  </label>

                  <ValidationObserver ref="messageObserver_sectionInfoLocation">
                    <ValidationProvider v-slot="{ errors }" rules="required">
                      <span
                        v-if="
                          isDeniedSQE(sectionInfoLocation.statusId) &&
                            sectionInfoLocation.denialComment != null
                        "
                        class="data-content d-block text-justify"
                      >
                        {{ sectionInfoLocation.denialComment | empty }}
                      </span>
                      <custom-text-area
                        v-else
                        v-model="sectionInfoLocation.denialComment"
                        :count-classes="['float-right']"
                        custom-error-msg="El comentario es requerido."
                        :disabled="isDeniedSQE(sectionInfoLocation.statusId)"
                        :error="errors[0]"
                        :maxlength="3000"
                        :show-char-count="
                          !isDeniedSQE(sectionInfoLocation.statusId)
                        "
                      />
                    </ValidationProvider>
                  </ValidationObserver>
                </div>
              </div>
              <div
                v-if="!isDeniedSQE(sectionInfoLocation.statusId)"
                class="row mt-5 pb-4"
              >
                <div class="col-12">
                  <action-button
                    class="float-right ml-2"
                    i="fas fa-save fa-lg"
                    text="Guardar"
                    variant="success"
                    @click="
                      () =>
                        onSaveLocation_Panel(
                          isVisibleLocation_DeniedPanel ? denied : approved
                        )
                    "
                  />
                  <action-button
                    class="float-right"
                    i="fas fa-times-circle"
                    text="Cancelar"
                    variant="outline-danger"
                    @click="() => onCancelLocation_Panel()"
                  />
                </div>
              </div>
            </div>
            <!-- Replacement request panel -->
            <div
              v-if="isVisibleLocation_ReplacementPanel"
              class="m-2 col-md-12 rounded align-items-center"
            >
              <div class="rounded p-2">
                <icon-view
                  class="p-1 rounded-circle"
                  icon="fas fa-arrow-from-right"
                  icon-color="#F3AF54"
                  icon-size="14px"
                  title="Razón de Solicitud de Reemplazo"
                  variant="custom-icon"
                />

                <div class="col-12 mt-3">
                  <label class="color-gray-6 font-14">Comentario:</label>
                  <validation-provider
                    ref="replacementRequestReasonRef_Location"
                    v-slot="{ errors }"
                    rules="required"
                  >
                    <span
                      v-if="
                        isReplacementRequestSQE(sectionInfoLocation.statusId) &&
                          sectionInfoLocation.statusComment != null
                      "
                      class="data-content d-block text-justify"
                    >
                      {{ sectionInfoLocation.statusComment | empty }}
                    </span>
                    <custom-text-area
                      v-else
                      v-model="sectionInfoLocation.replacementComment"
                      :count-classes="['float-right']"
                      custom-error-msg="El comentario es requerido."
                      :error="errors[0]"
                      :maxlength="3000"
                      show-char-count
                    />
                  </validation-provider>
                </div>
              </div>
              <div
                v-if="!isReplacementRequestSQE(sectionInfoLocation.statusId)"
                class="row mt-5 pb-4"
              >
                <div class="col-12">
                  <action-button
                    class="float-right ml-2"
                    i="fas fa-save fa-lg"
                    text="Guardar"
                    variant="success"
                    @click="onSaveLocation_GenericPanel(REPLACEMENTREQUESTEDQE)"
                  />
                  <action-button
                    class="float-right"
                    i="fas fa-times-circle"
                    text="Cancelar"
                    variant="outline-danger"
                    @click="onCancelLocation_ReplacementPanel()"
                  />
                </div>
              </div>
            </div>
            <!-- Conditional approve panel -->
            <div
              v-if="isVisibleLocation_ConditionalApprovePanel"
              class="m-2 col-md-12 rounded align-items-center"
            >
              <div class="rounded p-2">
                <icon-view
                  class="p-1 rounded-circle ml-2"
                  icon="fas fa-check"
                  icon-color="#F3AF54"
                  icon-size="14px"
                  title="Razón de Aprobación Condicionado"
                  variant="custom-icon"
                />
                <validation-observer
                  ref="messageObserver_conditionalApprovePanelLocation"
                >
                  <div class="row ml-2">
                    <div class="col-12 mt-3">
                      <validation-provider v-slot="{ errors }" rules="required">
                        <label class="color-gray-6 font-14">
                          Fecha de Término:
                        </label>
                        <span
                          v-if="
                            isConditionalApprovedSQE(
                              sectionInfoLocation.statusId
                            ) && sectionInfoLocation.statusEndDate != null
                          "
                          class="data-content d-block text-justify"
                        >
                          {{ sectionInfoLocation.statusEndDate | date }}
                        </span>
                        <custom-date-picker
                          v-else
                          v-model="sectionInfoLocation.statusEndDate"
                          :class-container="'w-100'"
                          :custom-error-msg="
                            'La fecha de término es requerida.'
                          "
                          :disabled="
                            isConditionalApprovedSQE(
                              sectionInfoLocation.statusId
                            )
                          "
                          :error="errors[0]"
                          format="dd/MMM./yyyy"
                          :min-date="getDate"
                          placeholder="DD/MM/YYYY"
                        />
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row ml-2">
                    <div class="col-12 mt-3">
                      <label class="color-gray-6 font-14">
                        Comentario:
                      </label>
                      <validation-provider v-slot="{ errors }" rules="required">
                        <span
                          v-if="
                            isConditionalApprovedSQE(
                              sectionInfoLocation.statusId
                            ) && sectionInfoLocation.statusComment != null
                          "
                          class="data-content d-block text-justify"
                        >
                          {{ sectionInfoLocation.statusComment | empty }}
                        </span>
                        <custom-text-area
                          v-else
                          v-model="sectionInfoLocation.statusComment"
                          :count-classes="['float-right']"
                          custom-error-msg="El comentario es requerido."
                          :error="errors[0]"
                          :maxlength="3000"
                          placeholder="Escriba un comentario"
                          show-char-count
                        />
                      </validation-provider>
                    </div>
                  </div>
                </validation-observer>
              </div>
              <div
                v-if="!isConditionalApprovedSQE(sectionInfoLocation.statusId)"
                class="row mt-5 pb-4"
              >
                <div class="col-12">
                  <action-button
                    class="float-right ml-2"
                    i="fas fa-save fa-lg"
                    text="Guardar"
                    variant="success"
                    @click="
                      () => onSaveLocation_GenericPanel(CONDITIONALAPPROVEDSQE)
                    "
                  />
                  <action-button
                    class="float-right"
                    i="fas fa-times-circle"
                    text="Cancelar"
                    variant="outline-danger"
                    @click="() => onCancelLocation_ConditionalApprovedPanel()"
                  />
                </div>
              </div>
            </div>
            <custom-tab class="custom-tabs">
              <custom-tab-item active lazy title="Localidad">
                <div class="col-md-12 row pr-0">
                  <div class="m-2 col-md-12 rounded px-1">
                    <!-- Locations -->
                    <locations-section
                      v-if="
                        isUniquePermissionInProviderRequestDocumentsEnabled !==
                          undefined
                      "
                      :academic-year-id="biddingAcademicYearId"
                      :company-id="+companyId"
                      :is-unique-permission-documents-enabled="
                        isUniquePermissionInProviderRequestDocumentsEnabled
                      "
                      :provider-type-id="providerType"
                      :status-id="sectionInfoLocation.statusId"
                      @expiring-locations="(v) => (expiringLocationsAlert = v)"
                      @on-cancel="isVisibleLocation = false"
                      @on-cancel_denied_panel="
                        isVisibleLocation_DeniedPanel = false
                      "
                      @on-cancel_replacement_panel="
                        isVisibleLocation_ReplacementPanel = false
                      "
                      @on-save="getSectionsProviderProfile"
                    />
                  </div>
                </div>
              </custom-tab-item>
              <custom-tab-item
                lazy
                title="Historial"
                @click="() => onTabClick(providerQuestionSection.Location)"
              >
                <profile-section-history
                  :items="sectionStatusHistoryMap.location"
                  @load="() => onTabClick(providerQuestionSection.Location)"
                />
              </custom-tab-item>
            </custom-tab>
          </div>
        </template>
      </custom-callout>

      <div
        v-if="expiringLocationsAlert.length > 0"
        class="alert px-2 rounded bg-secondary-41 border-0 expiring-locations-alert"
      >
        <div class="d-flex align-items-center">
          <em class="mr-3 fas fa-bell-exclamation" />
          <div>
            <span class="expiring-locations-alert__title">
              Las siguientes localidades tienen el Permiso Único próximo a
              vencer o vencido:
            </span>
            <div
              v-for="(loc, idx) in expiringLocationsAlert"
              :key="`expiring-loc-${idx}`"
              class="expiring-locations-alert__item"
            >
              {{ loc.description }} —
              <span class="expiring-locations-alert__date">
                {{ loc.isExpired ? 'Venció:' : 'Vence:' }}
                {{ loc.permissionUniqueDueDate | date }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!--Localidad-->

      <!--Recursos Financieros y Facturación-->
      <custom-callout
        :border-color="getColorStatus(sectionInfoFRB.statusId)"
        class-main="mt-3 rounded"
        :controlled="true"
        :has-toggle="
          isPendingSQE(sectionInfoFRB.statusId) ||
            isSubmittedSQE(sectionInfoFRB.statusId) ||
            isApprovedSQE(sectionInfoFRB.statusId) ||
            isDeniedSQE(sectionInfoFRB.statusId)
        "
        :opened="
          isVisibleFRB || isVisibleFRB_DeniedPanel || isVisibleFRB_ApprovePanel
        "
        @click:open="onToggleCallOutFRB(sectionInfoFRB.statusId)"
      >
        <div class="row py-2 mr-md-0 align-items-center">
          <div
            class="col-md-2 d-flex justify-content-center align-items-center"
          >
            <custom-balloon
              :background-color="
                `bg-${getColorStatus(sectionInfoFRB.statusId)}`
              "
              class="w-md-90 w-60 m-0"
              :text="sectionInfoFRB.statusName"
            />
          </div>
          <div class="row divider col-md-9">
            <div
              class="col-sm-12 mt-3 mt-md-0"
              :class="
                isApprovedSQE(sectionInfoFRB.statusId) ||
                isDeniedSQE(sectionInfoFRB.statusId)
                  ? 'col-md-4'
                  : 'col-md-6'
              "
            >
              <div class="color-gray-6 font-14">
                Información del Perfil:
              </div>
              <div class="color-black font-16">
                {{ sectionInfoFRB.sectionName | empty }}
              </div>
            </div>
            <div
              v-if="
                sectionInfoFRB.submittedDate &&
                  (isSubmittedSQE(sectionInfoFRB.statusId) ||
                    isApprovedSQE(sectionInfoFRB.statusId) ||
                    isDeniedSQE(sectionInfoFRB.statusId))
              "
              class="col-sm-12 mt-3 mt-md-0 col-md-2"
            >
              <div class="color-gray-6 font-14">Fecha de Sometido:</div>
              <div class="color-black font-16">
                {{ sectionInfoFRB.submittedDate | date }}
              </div>
            </div>
            <div
              v-if="
                sectionInfoFRB.lastStatusSubmittedDate &&
                  isSubmittedSQE(sectionInfoFRB.statusId) &&
                  !isApprovedSQE(sectionInfoFRB.statusId)
              "
              class="col-sm-12 mt-3 mt-md-0 col-md-2"
            >
              <div class="color-gray-6 font-14">Fecha de Último Estatus:</div>
              <div class="color-black font-16">
                {{ sectionInfoFRB.lastStatusSubmittedDate | date }}
              </div>
            </div>
            <div
              v-if="
                sectionInfoFRB.determinationDate &&
                  (isApprovedSQE(sectionInfoFRB.statusId) ||
                    isDeniedSQE(sectionInfoFRB.statusId))
              "
              class="col-sm-12 mt-3 mt-md-0 col-md-2"
            >
              <div class="color-gray-6 font-14">Fecha de Determinación:</div>
              <div class="color-black font-16">
                {{ sectionInfoFRB.determinationDate | date }}
              </div>
            </div>
            <div
              v-if="
                isApprovedSQE(sectionInfoFRB.statusId) ||
                  isDeniedSQE(sectionInfoFRB.statusId)
              "
              class="col-sm-12 mt-3 mt-md-0 col-md-2"
            >
              <div class="color-gray-6 font-14">Determinado por:</div>
              <div class="color-black font-16">
                {{ sectionInfoFRB.determinationBy | empty }}
              </div>
            </div>
          </div>
          <div class="row col-md-1 float-right">
            <action-button
              v-if="canApproveDenySQE(sectionInfoFRB.statusId)"
              class="btn-action-size"
              i="fas fa-check pl-1"
              variant="success m-1 pl-1"
              @click="() => onShowApprovePanelHandlerFRB()"
            />
            <action-button
              v-if="canApproveDenySQE(sectionInfoFRB.statusId)"
              class="btn-action-size"
              i="fas fa-ban pl-1"
              variant="outline-danger m-1 pl-1"
              @click="() => onShowDeniedPanelHandlerFRB(sectionInfoFRB)"
            />
            <action-button
              v-if="canEditSQE(sectionInfoFRB.statusId)"
              class="btn-action-size"
              i="fas fa-edit pl-1"
              variant="outline-success m-1 pl-1"
              @click="() => onGoEditHandlerFRB(sectionInfoFRB)"
            />
            <action-button
              v-if="canGoBackSQE(sectionInfoFRB.statusId)"
              class="btn-action-size"
              i="fas fa-undo pl-1"
              variant="success m-1 pl-1"
              @click="() => onGoBackStatusHandlerFRB(sectionInfoFRB)"
            />
          </div>
        </div>
        <template #edition>
          <div>
            <!-- Denegar request panel -->
            <div
              v-if="isVisibleFRB_DeniedPanel || isVisibleFRB_ApprovePanel"
              class="m-2 col-md-12 rounded align-items-center"
            >
              <div class="rounded p-2">
                <icon-view
                  v-if="isVisibleFRB_DeniedPanel"
                  class="p-1 rounded-circle"
                  icon="fas fa-times-circle"
                  icon-color="#FF7058"
                  icon-size="14px"
                  title="Razón de Rechazo"
                  variant="custom-icon"
                />
                <icon-view
                  v-if="isVisibleFRB_ApprovePanel"
                  class="p-1 rounded-circle"
                  icon="fas fa-check-circle "
                  icon-color="#008000"
                  icon-size="14px"
                  title="Razón de Aprobación"
                  variant="custom-icon"
                />

                <div class="col-12 mt-3">
                  <label class="color-gray-6 font-14">
                    {{
                      isDeniedSQE(sectionInfoFRB.statusId)
                        ? 'Razón de Denegación:'
                        : 'Comentario:'
                    }}
                  </label>
                  <ValidationObserver ref="messageObserver_sectionInfoFRB">
                    <ValidationProvider v-slot="{ errors }" rules="required">
                      <span
                        v-if="
                          isDeniedSQE(sectionInfoFRB.statusId) &&
                            sectionInfoFRB.denialComment != null
                        "
                        class="data-content d-block text-justify"
                      >
                        {{ sectionInfoFRB.denialComment | empty }}
                      </span>
                      <custom-text-area
                        v-else
                        id="textAreaReasonsectionInfoFRB"
                        v-model="sectionInfoFRB.denialComment"
                        :count-classes="['float-right']"
                        custom-error-msg="El comentario es requerido."
                        :disabled="isDeniedSQE(sectionInfoFRB.statusId)"
                        :error="errors[0]"
                        :maxlength="3000"
                        :show-char-count="!isDeniedSQE(sectionInfoFRB.statusId)"
                      />
                    </ValidationProvider>
                  </ValidationObserver>
                </div>
              </div>
              <div
                v-if="!isDeniedSQE(sectionInfoFRB.statusId)"
                class="row mt-5 pb-4"
              >
                <div class="col-12">
                  <action-button
                    id="actionBtnSaveSectionInfoFRB"
                    class="float-right ml-2"
                    i="fas fa-save fa-lg"
                    text="Guardar"
                    variant="success"
                    @click="
                      () =>
                        onSaveFRB_Panel(
                          isVisibleFRB_DeniedPanel ? denied : approved
                        )
                    "
                  />
                  <action-button
                    id="actionBtnCancelSectionInfoSQE"
                    class="float-right"
                    i="fas fa-times-circle"
                    text="Cancelar"
                    variant="outline-danger"
                    @click="() => onCancelFRB_Panel()"
                  />
                </div>
              </div>
            </div>
            <!-- Denegar approved panel -->
          </div>
          <custom-tab class="custom-tabs">
            <custom-tab-item
              active
              lazy
              title="Recursos Financieros y Facturación"
            >
              <div class="col-md-12 row pr-0">
                <div class="m-2 col-md-12 rounded">
                  <financial-resources-billing
                    v-if="isVisibleFRB"
                    ref="FinancialResourcesBilling"
                    :bidding-academic-year-id="biddingAcademicYearId"
                    :provider-id="providerInfo?.companyId"
                    :questions="questionsFRB"
                    :section-title="sectionInfoFRB.sectionName"
                    :status-id="sectionInfoFRB.statusId"
                    @on-cancel="isVisibleFRB = false"
                    @on-save="getSectionsProviderProfile"
                  />
                </div>
              </div>
            </custom-tab-item>
            <custom-tab-item
              lazy
              title="Historial"
              @click="
                () =>
                  onTabClick(providerQuestionSection.FinancialResourcesBilling)
              "
            >
              <profile-section-history
                :items="sectionStatusHistoryMap.financialResourcesBilling"
              />
            </custom-tab-item>
          </custom-tab>
        </template>
      </custom-callout>
      <!--Recursos Financieros y Facturación-->

      <!--Servidores Públicos-->
      <custom-callout
        :border-color="getColorStatus(sectionInfoPO.statusId)"
        class-main="mt-3 rounded"
        :controlled="true"
        :has-toggle="
          isPendingSQE(sectionInfoPO.statusId) ||
            isSubmittedSQE(sectionInfoPO.statusId) ||
            isApprovedSQE(sectionInfoPO.statusId) ||
            isDeniedSQE(sectionInfoPO.statusId)
        "
        :opened="
          isVisiblePO || isVisiblePO_DeniedPanel || isVisiblePO_ApprovePanel
        "
        @click:open="onToggleCallOutPO(sectionInfoPO.statusId)"
      >
        <div class="row py-2 mr-md-0 align-items-center">
          <div
            class="col-md-2 d-flex justify-content-center align-items-center"
          >
            <custom-balloon
              :background-color="`bg-${getColorStatus(sectionInfoPO.statusId)}`"
              class="w-md-90 w-60 m-0"
              :text="sectionInfoPO.statusName"
            />
          </div>
          <div class="row divider col-md-9">
            <div
              class="col-sm-12 mt-3 mt-md-0"
              :class="
                isApprovedSQE(sectionInfoPO.statusId) ||
                isDeniedSQE(sectionInfoPO.statusId)
                  ? 'col-md-4'
                  : 'col-md-6'
              "
            >
              <div class="color-gray-6 font-14">
                Información del Perfil:
              </div>
              <div class="color-black font-16">
                {{ sectionInfoPO.sectionName | empty }}
              </div>
            </div>
            <div
              v-if="
                sectionInfoPO.submittedDate &&
                  (isSubmittedSQE(sectionInfoPO.statusId) ||
                    isApprovedSQE(sectionInfoPO.statusId) ||
                    isDeniedSQE(sectionInfoPO.statusId))
              "
              class="col-sm-12 mt-3 mt-md-0 col-md-2"
            >
              <div class="color-gray-6 font-14">Fecha de Sometido:</div>
              <div class="color-black font-16">
                {{ sectionInfoPO.submittedDate | date }}
              </div>
            </div>
            <div
              v-if="
                sectionInfoPO.lastStatusSubmittedDate &&
                  isSubmittedSQE(sectionInfoPO.statusId) &&
                  !isApprovedSQE(sectionInfoPO.statusId)
              "
              class="col-sm-12 mt-3 mt-md-0 col-md-2"
            >
              <div class="color-gray-6 font-14">Fecha de Último Estatus:</div>
              <div class="color-black font-16">
                {{ sectionInfoPO.lastStatusSubmittedDate | date }}
              </div>
            </div>
            <div
              v-if="
                sectionInfoPO.determinationDate &&
                  (isApprovedSQE(sectionInfoPO.statusId) ||
                    isDeniedSQE(sectionInfoPO.statusId))
              "
              class="col-sm-12 mt-3 mt-md-0 col-md-2"
            >
              <div class="color-gray-6 font-14">Fecha de Determinación:</div>
              <div class="color-black font-16">
                {{ sectionInfoPO.determinationDate | date }}
              </div>
            </div>
            <div
              v-if="
                isApprovedSQE(sectionInfoPO.statusId) ||
                  isDeniedSQE(sectionInfoPO.statusId)
              "
              class="col-sm-12 mt-3 mt-md-0 col-md-2"
            >
              <div class="color-gray-6 font-14">Determinado por:</div>
              <div class="color-black font-16">
                {{ sectionInfoPO.determinationBy | empty }}
              </div>
            </div>
          </div>
          <div class="row col-md-1">
            <action-button
              v-if="canApproveDenySQE(sectionInfoPO.statusId)"
              class="btn-action-size"
              i="fas fa-check pl-1"
              variant="success m-1 pl-1"
              @click="() => onShowApprovePanelHandlerPO()"
            />
            <action-button
              v-if="canApproveDenySQE(sectionInfoPO.statusId)"
              class="btn-action-size"
              i="fas fa-ban pl-1"
              variant="outline-danger m-1 pl-1"
              @click="() => onShowDeniedPanelHandlerPO(sectionInfoPO)"
            />
            <action-button
              v-if="canEditSQE(sectionInfoPO.statusId)"
              class="btn-action-size"
              i="fas fa-edit pl-1"
              variant="outline-success m-1 pl-1"
              @click="() => onGoEditHandlerPO(sectionInfoPO)"
            />
            <action-button
              v-if="canGoBackSQE(sectionInfoPO.statusId)"
              class="btn-action-size"
              i="fas fa-undo pl-1"
              variant="success m-1 pl-1"
              @click="() => onGoBackStatusHandlerFRB(sectionInfoPO)"
            />
          </div>
        </div>
        <template #edition>
          <div>
            <!-- Denegar request panel -->
            <div
              v-if="isVisiblePO_DeniedPanel || isVisiblePO_ApprovePanel"
              class="m-2 col-md-12 rounded align-items-center"
            >
              <div class="rounded p-2">
                <icon-view
                  v-if="isVisiblePO_DeniedPanel"
                  class="p-1 rounded-circle"
                  icon="fas fa-times-circle"
                  icon-color="#FF7058"
                  icon-size="14px"
                  title="Razón de Rechazo"
                  variant="custom-icon"
                />
                <icon-view
                  v-if="isVisiblePO_ApprovePanel"
                  class="p-1 rounded-circle"
                  icon="fas fa-check-circle "
                  icon-color="#008000"
                  icon-size="14px"
                  title="Razón de Aprobación"
                  variant="custom-icon"
                />

                <div class="col-12 mt-3">
                  <label class="color-gray-6 font-14">
                    {{
                      isDeniedSQE(sectionInfoPO.statusId)
                        ? 'Razón de Denegación:'
                        : 'Comentario:'
                    }}
                  </label>
                  <ValidationObserver ref="messageObserver_sectionInfoPO">
                    <ValidationProvider v-slot="{ errors }" rules="required">
                      <span
                        v-if="
                          isDeniedSQE(sectionInfoPO.statusId) &&
                            sectionInfoPO.denialComment != null
                        "
                        class="data-content d-block text-justify"
                      >
                        {{ sectionInfoPO.denialComment | empty }}
                      </span>
                      <custom-text-area
                        v-else
                        id="textAreaReasonsectionInfoPO"
                        v-model="sectionInfoPO.denialComment"
                        :count-classes="['float-right']"
                        custom-error-msg="El comentario es requerido."
                        :disabled="isDeniedSQE(sectionInfoPO.statusId)"
                        :error="errors[0]"
                        :maxlength="3000"
                        :show-char-count="!isDeniedSQE(sectionInfoPO.statusId)"
                      />
                    </ValidationProvider>
                  </ValidationObserver>
                </div>
              </div>
              <div
                v-if="!isDeniedSQE(sectionInfoPO.statusId)"
                class="row mt-5 pb-4"
              >
                <div class="col-12">
                  <action-button
                    id="actionBtnSaveSectionInfoPO"
                    class="float-right ml-2"
                    i="fas fa-save fa-lg"
                    text="Guardar"
                    variant="success"
                    @click="
                      () =>
                        onSavePO_Panel(
                          isVisiblePO_DeniedPanel ? denied : approved
                        )
                    "
                  />
                  <action-button
                    id="actionBtnCancelSectionInfoPO"
                    class="float-right"
                    i="fas fa-times-circle"
                    text="Cancelar"
                    variant="outline-danger"
                    @click="() => onCancelPO_Panel()"
                  />
                </div>
              </div>
            </div>
            <!-- Denegar approved panel -->
          </div>
          <custom-tab class="custom-tabs">
            <custom-tab-item active lazy title="Servidores Públicos" />
            <custom-tab-item
              lazy
              title="Historial"
              @click="
                () => onTabClick(providerQuestionSection.PublicOfficialsSection)
              "
            >
              <profile-section-history
                :items="sectionStatusHistoryMap.publicOfficialsSection"
              />
            </custom-tab-item>
          </custom-tab>
          <div class="col-md-12 row pr-0">
            <div
              class="m-2 col-md-12 rounded"
              :class="!isVisiblePO_DeniedPanel ? 'bg-white' : ''"
            >
              <!-- Public officials -->
              <public-officials-section
                v-if="isVisiblePO"
                ref="publicOfficialsSection"
                :bidding-academic-year-id="biddingAcademicYearId"
                :provider-id="providerInfo?.companyId"
                :provider-type-id="providerType"
                :questions="questionsPO"
                :section-description="sectionInfoPO.sectionDescription"
                :section-title="sectionInfoPO.sectionName"
                :status-id="sectionInfoPO.statusId"
                @on-cancel="isVisiblePO = false"
                @on-save="getSectionsProviderProfile"
              />
            </div>
          </div>
        </template>
      </custom-callout>
      <!--Servidores Públicos-->

      <!--Áreas Geográficas-->
      <custom-callout
        :border-color="getColorStatus(sectionInfoGA.statusId)"
        class-main="mt-3 rounded"
        :controlled="true"
        :has-toggle="
          isPendingSQE(sectionInfoGA.statusId) ||
            isSubmittedSQE(sectionInfoGA.statusId) ||
            isApprovedSQE(sectionInfoGA.statusId) ||
            isDeniedSQE(sectionInfoGA.statusId)
        "
        :opened="
          isVisibleGA || isVisibleGA_DeniedPanel || isVisibleGA_ApprovePanel
        "
        @click:open="onToggleCallOutGA(sectionInfoGA.statusId)"
      >
        <div class="row py-2 mr-md-0 align-items-center">
          <div
            class="col-md-2 d-flex justify-content-center align-items-center"
          >
            <custom-balloon
              :background-color="`bg-${getColorStatus(sectionInfoGA.statusId)}`"
              class="w-md-90 w-60 m-0"
              :text="sectionInfoGA.statusName"
            />
          </div>
          <div class="row divider col-md-9">
            <div
              class="col-sm-12 mt-3 mt-md-0"
              :class="
                isApprovedSQE(sectionInfoGA.statusId) ||
                isDeniedSQE(sectionInfoGA.statusId)
                  ? 'col-md-4'
                  : 'col-md-6'
              "
            >
              <div class="color-gray-6 font-14">
                Información del Perfil:
              </div>
              <div class="color-black font-16">
                {{ sectionInfoGA.sectionName | empty }}
              </div>
            </div>
            <div
              v-if="
                sectionInfoGA.submittedDate &&
                  (isSubmittedSQE(sectionInfoGA.statusId) ||
                    isApprovedSQE(sectionInfoGA.statusId) ||
                    isDeniedSQE(sectionInfoGA.statusId))
              "
              class="col-sm-12 mt-3 mt-md-0 col-md-2"
            >
              <div class="color-gray-6 font-14">Fecha de Sometido:</div>
              <div class="color-black font-16">
                {{ sectionInfoGA.submittedDate | date }}
              </div>
            </div>
            <div
              v-if="
                sectionInfoGA.lastStatusSubmittedDate &&
                  isSubmittedSQE(sectionInfoGA.statusId) &&
                  !isApprovedSQE(sectionInfoGA.statusId)
              "
              class="col-sm-12 mt-3 mt-md-0 col-md-2"
            >
              <div class="color-gray-6 font-14">Fecha de Último Estatus:</div>
              <div class="color-black font-16">
                {{ sectionInfoGA.lastStatusSubmittedDate | date }}
              </div>
            </div>
            <div
              v-if="
                sectionInfoGA.determinationDate &&
                  (isApprovedSQE(sectionInfoGA.statusId) ||
                    isDeniedSQE(sectionInfoGA.statusId))
              "
              class="col-sm-12 mt-3 mt-md-0 col-md-2"
            >
              <div class="color-gray-6 font-14">Fecha de Determinación:</div>
              <div class="color-black font-16">
                {{ sectionInfoGA.determinationDate | date }}
              </div>
            </div>
            <div
              v-if="
                isApprovedSQE(sectionInfoGA.statusId) ||
                  isDeniedSQE(sectionInfoGA.statusId)
              "
              class="col-sm-12 mt-3 mt-md-0 col-md-2"
            >
              <div class="color-gray-6 font-14">Determinado por:</div>
              <div class="color-black font-16">
                {{ sectionInfoGA.determinationBy | empty }}
              </div>
            </div>
          </div>
          <div class="row col-md-1 float-right">
            <action-button
              v-if="canApproveDenySQE(sectionInfoGA.statusId)"
              class="btn-action-size"
              i="fas fa-check pl-1"
              variant="success m-1 pl-1"
              @click="() => onShowApprovePanelHandlerGA()"
            />
            <action-button
              v-if="canApproveDenySQE(sectionInfoGA.statusId)"
              class="btn-action-size"
              i="fas fa-ban pl-1"
              variant="outline-danger m-1 pl-1"
              @click="() => onShowDeniedPanelHandlerGA(sectionInfoGA)"
            />
            <action-button
              v-if="canEditSQE(sectionInfoGA.statusId)"
              class="btn-action-size"
              i="fas fa-edit pl-1"
              variant="outline-success m-1 pl-1"
              @click="() => onGoEditHandlerGA(sectionInfoGA)"
            />
            <action-button
              v-if="canGoBackSQE(sectionInfoGA.statusId)"
              class="btn-action-size"
              i="fas fa-undo pl-1"
              variant="success m-1 pl-1"
              @click="() => onGoBackStatusHandlerSQE(sectionInfoGA)"
            />
          </div>
        </div>
        <template #edition>
          <div>
            <!-- Denegar request panel -->
            <div
              v-if="isVisibleGA_DeniedPanel || isVisibleGA_ApprovePanel"
              class="m-2 col-md-12 rounded align-items-center"
            >
              <div class="rounded p-2">
                <icon-view
                  v-if="isVisibleGA_DeniedPanel"
                  class="p-1 rounded-circle"
                  icon="fas fa-times-circle"
                  icon-color="#FF7058"
                  icon-size="14px"
                  title="Razón de Rechazo"
                  variant="custom-icon"
                />

                <icon-view
                  v-if="isVisibleGA_ApprovePanel"
                  class="p-1 rounded-circle"
                  icon="fas fa-check-circle "
                  icon-color="#008000"
                  icon-size="14px"
                  title="Razón de Aprobación"
                  variant="custom-icon"
                />
                <div class="col-12 mt-3">
                  <label class="color-gray-6 font-14">
                    {{
                      isDeniedSQE(sectionInfoGA.statusId)
                        ? 'Razón de Denegación:'
                        : 'Comentario:'
                    }}
                  </label>
                  <ValidationObserver ref="messageObserver_sectionInfoGA">
                    <ValidationProvider v-slot="{ errors }" rules="required">
                      <span
                        v-if="
                          isDeniedSQE(sectionInfoGA.statusId) &&
                            sectionInfoGA.denialComment != null
                        "
                        class="data-content d-block text-justify"
                      >
                        {{ sectionInfoGA.denialComment | empty }}
                      </span>
                      <custom-text-area
                        v-else
                        id="textAreaReasonsectionInfoGA"
                        v-model="sectionInfoGA.denialComment"
                        :count-classes="['float-right']"
                        custom-error-msg="El comentario es requerido."
                        :disabled="isDeniedSQE(sectionInfoGA.statusId)"
                        :error="errors[0]"
                        :maxlength="3000"
                        :show-char-count="!isDeniedSQE(sectionInfoGA.statusId)"
                      />
                    </ValidationProvider>
                  </ValidationObserver>
                </div>
              </div>
              <div
                v-if="!isDeniedSQE(sectionInfoGA.statusId)"
                class="row mt-5 pb-4"
              >
                <div class="col-12">
                  <action-button
                    id="actionBtnSavesectionInfoGA"
                    class="float-right ml-2"
                    i="fas fa-save fa-lg"
                    text="Guardar"
                    variant="success"
                    @click="
                      () =>
                        onSaveGA_Panel(
                          isVisibleGA_DeniedPanel ? denied : approved
                        )
                    "
                  />
                  <action-button
                    id="actionBtnCancelsectionInfoGA"
                    class="float-right"
                    i="fas fa-times-circle"
                    text="Cancelar"
                    variant="outline-danger"
                    @click="() => onCancelGA_Panel()"
                  />
                </div>
              </div>
            </div>
            <!-- Denegar approved panel -->
          </div>
          <custom-tab class="custom-tabs">
            <custom-tab-item active lazy title="Áreas Geográficas">
              <div class="col-md-12 row pr-0">
                <div class="m-2 col-md-12 rounded">
                  <geographic-areas
                    v-if="isVisibleGA"
                    ref="GeographicAreas"
                    :bidding-academic-year-id="biddingAcademicYearId"
                    :options="optionsGA"
                    :provider-id="providerInfo?.companyId"
                    :section-title="sectionInfoGA.sectionName"
                    :status-id="sectionInfoGA.statusId"
                    @on-cancel="isVisibleGA = false"
                    @on-save="getSectionsProviderProfile"
                  />
                </div>
              </div>
            </custom-tab-item>
            <custom-tab-item
              lazy
              title="Historial"
              @click="() => onTabClick(providerQuestionSection.GeographicAreas)"
            >
              <profile-section-history
                :items="sectionStatusHistoryMap.geographicAreas"
              />
            </custom-tab-item>
          </custom-tab>
        </template>
      </custom-callout>
      <!--Áreas Geográficas-->

      <!--Datos de servicios a ofrecer-->
      <custom-callout
        v-if="sectionInfoOS.statusName"
        :border-color="getColorStatus(sectionInfoOS.statusId)"
        class-main="mt-3 rounded"
        :controlled="true"
        :has-toggle="
          isPendingSQE(sectionInfoOS.statusId) ||
            isSubmittedSQE(sectionInfoOS.statusId) ||
            isApprovedSQE(sectionInfoOS.statusId) ||
            isDeniedSQE(sectionInfoOS.statusId)
        "
        :opened="
          isVisibleOS || isVisibleOS_DeniedPanel || isVisibleOS_ApprovePanel
        "
        @click:open="onToggleCallOutOS(sectionInfoOS.statusId)"
      >
        <div class="row py-2 mr-md-0 align-items-center">
          <div
            class="col-md-2 d-flex justify-content-center align-items-center"
          >
            <custom-balloon
              :background-color="`bg-${getColorStatus(sectionInfoOS.statusId)}`"
              class="w-md-90 w-60 m-0"
              :text="sectionInfoOS.statusName"
            />
          </div>
          <div class="row divider col-md-9">
            <div
              class="col-sm-12 mt-3 mt-md-0"
              :class="
                isApprovedSQE(sectionInfoOS.statusId) ||
                isDeniedSQE(sectionInfoOS.statusId)
                  ? 'col-md-4'
                  : 'col-md-6'
              "
            >
              <div class="color-gray-6 font-14">
                Información del Perfil:
              </div>
              <div class="color-black font-16">
                {{ sectionInfoOS.sectionName | empty }}
              </div>
            </div>
            <div
              v-if="
                sectionInfoOS.submittedDate &&
                  (isSubmittedSQE(sectionInfoOS.statusId) ||
                    isApprovedSQE(sectionInfoOS.statusId) ||
                    isDeniedSQE(sectionInfoOS.statusId))
              "
              class="col-sm-12 mt-3 mt-md-0 col-md-2"
            >
              <div class="color-gray-6 font-14">Fecha de Sometido:</div>
              <div class="color-black font-16">
                {{ sectionInfoOS.submittedDate | date }}
              </div>
            </div>
            <div
              v-if="
                sectionInfoOS.lastStatusSubmittedDate &&
                  isSubmittedSQE(sectionInfoOS.statusId)
              "
              class="col-sm-12 mt-3 mt-md-0 col-md-2"
            >
              <div class="color-gray-6 font-14">Fecha de Último Estatus:</div>
              <div class="color-black font-16">
                {{ sectionInfoOS.lastStatusSubmittedDate | date }}
              </div>
            </div>
            <div
              v-if="
                sectionInfoOS.lastStatusSubmittedDate &&
                  (isApprovedSQE(sectionInfoOS.statusId) ||
                    isDeniedSQE(sectionInfoOS.statusId))
              "
              class="col-sm-12 mt-3 mt-md-0 col-md-2"
            >
              <div class="color-gray-6 font-14">Fecha de Determinación:</div>
              <div class="color-black font-16">
                {{ sectionInfoOS.determinationDate | date }}
              </div>
            </div>
            <div
              v-if="
                isApprovedSQE(sectionInfoOS.statusId) ||
                  isDeniedSQE(sectionInfoOS.statusId)
              "
              class="col-sm-12 mt-3 mt-md-0 col-md-2"
            >
              <div class="color-gray-6 font-14">Determinado por:</div>
              <div class="color-black font-16">
                {{ sectionInfoOS.determinationBy | empty }}
              </div>
            </div>
          </div>
          <div
            v-if="
              isApprovedSQE(sectionInfoOS.statusId) ||
                isDeniedSQE(sectionInfoOS.statusId)
            "
            class="col-md-1 row"
          >
            <action-button
              v-if="canEditSQE(sectionInfoOS.statusId)"
              class="btn-action-size"
              i="fas fa-edit pl-1"
              variant="outline-success m-1 pl-1"
              @click="() => onGoEditHandlerOS(sectionInfoOS)"
            />
            <action-button
              v-if="canGoBackSQE(sectionInfoOS.statusId)"
              class="btn-action-size"
              i="fas fa-undo pl-1"
              variant="success m-1 pl-1"
              @click="() => onGoBackStatusHandlerSQE(sectionInfoOS)"
            />
          </div>
          <div
            v-if="isSubmittedSQE(sectionInfoOS.statusId)"
            class="col-md-1 row"
          >
            <action-button
              v-if="canApproveDenySQE(sectionInfoOS.statusId)"
              class="btn-action-size"
              i="fas fa-check pl-1"
              variant="success m-1 pl-1"
              @click="() => onShowApprovePanelHandlerOS()"
            />
            <action-button
              v-if="canApproveDenySQE(sectionInfoOS.statusId)"
              class="btn-action-size"
              i="fas fa-ban pl-1"
              variant="outline-danger m-1 pl-1"
              @click="() => onShowDeniedPanelHandlerOS(sectionInfoOS)"
            />
          </div>
        </div>
        <template #edition>
          <div>
            <!-- Denegar request panel -->
            <div
              v-if="isVisibleOS_DeniedPanel || isVisibleOS_ApprovePanel"
              class="m-2 col-md-12 rounded align-items-center"
            >
              <div class="rounded p-2">
                <icon-view
                  v-if="isVisibleOS_DeniedPanel"
                  class="p-1 rounded-circle"
                  icon="fas fa-times-circle"
                  icon-color="#FF7058"
                  icon-size="14px"
                  title="Razón de Rechazo"
                  variant="custom-icon"
                />
                <icon-view
                  v-if="isVisibleOS_ApprovePanel"
                  class="p-1 rounded-circle"
                  icon="fas fa-check-circle "
                  icon-color="#008000"
                  icon-size="14px"
                  title="Razón de Aprobación"
                  variant="custom-icon"
                />

                <div class="col-12 mt-3">
                  <label class="color-gray-6 font-14">
                    {{
                      isDeniedSQE(sectionInfoOS.statusId)
                        ? 'Razón de Denegación:'
                        : 'Comentario:'
                    }}
                  </label>

                  <ValidationObserver ref="messageObserver_sectionInfoOS">
                    <ValidationProvider v-slot="{ errors }" rules="required">
                      <span
                        v-if="
                          isDeniedSQE(sectionInfoOS.statusId) &&
                            sectionInfoOS.denialComment != null
                        "
                        class="data-content d-block text-justify"
                      >
                        {{ sectionInfoOS.denialComment | empty }}
                      </span>
                      <custom-text-area
                        v-else
                        v-model="sectionInfoOS.denialComment"
                        :count-classes="['float-right']"
                        custom-error-msg="El comentario es requerido."
                        :disabled="isDeniedSQE(sectionInfoOS.statusId)"
                        :error="errors[0]"
                        :maxlength="3000"
                        :show-char-count="!isDeniedSQE(sectionInfoOS.statusId)"
                      />
                    </ValidationProvider>
                  </ValidationObserver>
                </div>
              </div>
              <div
                v-if="!isDeniedSQE(sectionInfoOS.statusId)"
                class="row mt-5 pb-4"
              >
                <div class="col-12">
                  <action-button
                    class="float-right ml-2"
                    i="fas fa-save fa-lg"
                    text="Guardar"
                    variant="success"
                    @click="
                      () =>
                        onSaveOS_Panel(
                          isVisibleOS_DeniedPanel ? denied : approved
                        )
                    "
                  />
                  <action-button
                    class="float-right"
                    i="fas fa-times-circle"
                    text="Cancelar"
                    variant="outline-danger"
                    @click="() => onCancelOS_Panel()"
                  />
                </div>
              </div>
            </div>
          </div>
          <custom-tab class="custom-tabs">
            <custom-tab-item active lazy title="Datos de servicios a ofrecer">
              <div class="col-md-12 row pr-0">
                <div class="m-2 col-md-12 rounded px-1">
                  <!-- Offered Services -->
                  <services-to-offer-section
                    v-if="isVisibleOS"
                    :academic-year-id="+academicYearId"
                    :company-id="+companyId"
                    :status-id="sectionInfoOS.statusId"
                    @on-cancel="isVisibleOS = false"
                    @on-save="getSectionsProviderProfile"
                  />
                </div>
              </div>
            </custom-tab-item>
            <custom-tab-item
              lazy
              title="Historial"
              @click="() => onTabClick(providerQuestionSection.ServicesToOffer)"
            >
              <profile-section-history
                :items="sectionStatusHistoryMap.servicesToOffer"
              />
            </custom-tab-item>
          </custom-tab>
        </template>
      </custom-callout>
      <!--Datos de servicios a ofrecer-->
    </div>

    <div class="mt-4">
      <section-title
        content="Estatus de los documentos de la solicitud"
        :has-line="true"
      />
      <custom-result-not-found
        v-if="!documents.length"
        text="No se encontraron documentos para el año fiscal"
      />
      <document-status-bar v-if="canShowStatusBar" :documents="documents" />
      <section-title
        class="mt-4"
        content="Documentos de la Solicitud"
        :has-line="true"
      />
      <validation-observer
        ref="documentRef"
        v-slot="{}"
        class="mt-4"
        tag="form"
      >
        <div
          v-for="(item, index) in documents"
          :key="`document-index-${index}`"
        >
          <custom-callout
            :border-color="getColorStatus(item.statusId)"
            class-main="mt-3 rounded"
            :controlled="true"
            :has-toggle="true"
            :opened="
              ((item.deniedPanel.editting ||
                item.approvePanel.editting ||
                item.replacementRequestPanel.editting ||
                item.conditionalApprovedPanel.editting) &&
                activeIndex === null) ||
                activeIndex === index
            "
            @click:open="onToggleCallout(item, index)"
          >
            <div class="row py-2 mr-md-0 align-items-center">
              <div
                class="col-md-3 d-flex justify-content-center align-items-center"
              >
                <custom-balloon
                  :background-color="`bg-${getColorStatus(item.statusId)}`"
                  class="w-md-90 w-60 m-0"
                  :text="item.statusName"
                />
              </div>
              <div class="row mx-auto divider col-md-9">
                <div
                  class="col-sm-12 mt-3 mt-md-0"
                  :class="hasViewGroupPermission ? 'col-md-4' : 'col-md-5'"
                >
                  <div class="color-gray-6 font-14">Tipo de Documento:</div>
                  <div class="color-black font-16">
                    {{ item.documentTypeName | empty }}
                  </div>
                </div>
                <div
                  class="col-md-3 col-sm-12 mt-3 mt-md-0"
                  :class="hasViewGroupPermission ? 'col-md-2' : 'col-md-4'"
                >
                  <div class="color-gray-6 font-14">Archivo:</div>
                  <div class="color-black font-16">
                    {{ item.filename | empty }}
                  </div>
                </div>
                <div
                  v-if="hasViewGroupPermission"
                  class="col-md-2 col-sm-12 mt-3 mt-md-0"
                >
                  <div class="color-gray-6 font-14">Grupo:</div>
                  <div class="color-black font-16">
                    {{ getGroupType(item.groupType) }}
                  </div>
                </div>
                <div
                  class="col-md-3 col-sm-12 mt-3 mt-md-0 d-flex justify-content-end align-items-center"
                >
                  <action-button
                    v-if="canDownload(item)"
                    class="btn-action-size"
                    i="fas fa-file-download"
                    variant="success m-1"
                    @click="() => onDownloadHandler(item)"
                  />
                  <action-button
                    v-if="isDenied(item.statusId) && item.isExempted"
                    class="btn-action-size"
                    i="mr-2 fas fa-times-circle"
                    variant="danger m-1"
                    @click="() => onNoApplyRemoveHandler(item, item.isExempted)"
                  />

                  <action-button
                    v-if="canApproveDeny(item.statusId)"
                    class="btn-action-size"
                    i="fas fa-check pl-1"
                    variant="outline-success m-1 pl-1"
                    @click="() => onShowApproveDocumentPanelHandler(item)"
                  />

                  <action-button
                    v-if="canConditionalApprove(item)"
                    id="actionBtnShowConditionalApproved"
                    class="btn-action-size"
                    i="fas fa-check pl-1"
                    variant="outline-warning m-1 pl-1"
                    @click="() => onShowConditionalApproveHandler(item)"
                  />

                  <action-button
                    v-if="canReplacementRequest(item.statusId)"
                    id="actionBtnShowReplacementRequest"
                    class="btn-action-size"
                    i="fas fa-arrow-from-right pl-1"
                    variant="warning m-1 pl-1"
                    @click="() => onShowReplacementRequestHandler(item)"
                  />

                  <action-button
                    v-if="canApproveDeny(item.statusId)"
                    class="btn-action-size"
                    i="fas fa-ban pl-1"
                    variant="outline-danger m-1 pl-1"
                    @click="() => onShowDeniedDocumentPanelHandler(item)"
                  />

                  <action-button
                    v-if="canGoBack(item.statusId)"
                    class="btn-action-size"
                    i="fas fa-undo pl-1"
                    variant="outline-success m-1 pl-1"
                    @click="() => onGoBackStatusHandler(item)"
                  />

                  <custom-file-input
                    v-if="canReplace(item) && !item.isExempted"
                    ref="replaceFileInputRef"
                    accept=".pdf"
                    accept-terms-modal-title="Certificación"
                    accept-terms-text="Certifico que este documento que he subido al Sistema REMPRO es copia fiel y exacta del original que pertenece a los récords de la Unidad Secretarial del Procedimiento de Querellas y Remedio Provisional (USPQRP) y que como proveedor de servicios seré custodio del mismo. Reconozco y acepto que este documento original me puede ser solicitado por la USPQRP en cualquier momento.(0423)"
                    accept-terms-title="Acepto los términos y responsabilidades"
                    accept-terms-validation-msg="Favor certifique el documento que ha subido al sistema REMPRO."
                    add-icon="fa fa-file-upload"
                    allow-accept-terms
                    :attachment-id="item.documentId"
                    class="file-input__extended"
                    display-style="normal"
                    :just-upload="true"
                    label-position="left"
                    name=" "
                    :on-download="() => onDownloadHandler(item)"
                    :value="item.attachment"
                    @after-remove="onRemoveHandler(item)"
                    @input="(file) => onReplaceFileHandler(file, item)"
                  />

                  <custom-file-input
                    v-if="
                      ((canUpload(item) || !canDownload(item)) &&
                        !item.isExempted) ||
                        isDeniedDocument(item)
                    "
                    ref="fileInputRef"
                    accept=".pdf"
                    accept-terms-modal-title="Certificación"
                    accept-terms-text="Certifico que este documento que he subido al Sistema REMPRO es copia fiel y exacta del original que pertenece a los récords de la Unidad Secretarial del Procedimiento de Querellas y Remedio Provisional (USPQRP) y que como proveedor de servicios seré custodio del mismo. Reconozco y acepto que este documento original me puede ser solicitado por la USPQRP en cualquier momento. Cualquier alteración, tachadura o modificación indebida en los documentos podrá ser referida a las agencias pertinentes para la toma de acción fiscal y legal correspondiente.(0423)"
                    accept-terms-title="Acepto los términos y responsabilidades"
                    accept-terms-validation-msg="Favor certifique el documento que ha subido al sistema REMPRO."
                    allow-accept-terms
                    :attachment-id="item.documentId"
                    class="file-input__extended"
                    display-style="normal"
                    :just-upload="canUpload(item)"
                    label-position="left"
                    name=" "
                    :on-download="() => onDownloadHandler(item)"
                    :value="item.attachment"
                    @after-remove="onRemoveHandler(item)"
                    @input="(file) => onUploadFileHandler(file, item)"
                  />
                </div>
                <div
                  v-if="
                    item.lastStatusSubmittedDate &&
                      !documentIsStatusPending(item)
                  "
                  class="col-sm-12 mt-3 mt-md-5"
                  :class="hasViewGroupPermission ? 'col-md-4' : 'col-md-5'"
                >
                  <div class="color-gray-6 font-14">Fecha de Sometido:</div>
                  <div class="color-black font-16">
                    {{ item.lastStatusSubmittedDate | date }}
                  </div>
                </div>
                <div
                  v-if="item.lastStatusSubmittedDate"
                  class="col-sm-12 mt-3 mt-md-5"
                  :class="hasViewGroupPermission ? 'col-md-3' : 'col-md-3'"
                >
                  <div class="color-gray-6 font-14">
                    Fecha de Último Estatus:
                  </div>
                  <div class="color-black font-16">
                    {{ item.lastStatusDate | date }}
                  </div>
                </div>
                <div
                  v-if="item.documentEndDate"
                  class="col-sm-12 mt-3 mt-md-5"
                  :class="hasViewGroupPermission ? 'col-md-3' : 'col-md-3'"
                >
                  <div class="color-gray-6 font-14">
                    Fecha de Término:
                  </div>
                  <div class="color-black font-16">
                    {{ item.documentEndDate | date }}
                  </div>
                </div>
                <div
                  v-if="isApplicableDocument(item.contractDocumentTypeId)"
                  class="col-sm-12 mt-3 mt-md-5 d-flex align-items-center"
                  :class="
                    `${hasViewGroupPermission ? 'col-md-4' : 'col-md-3 pl-0'}`
                  "
                >
                  <check-box
                    ref="exempted"
                    v-model="item.isExempted"
                    class="checkbox text-gray-16"
                    :disabled="
                      (!isPending(item.statusId) && !isDenied(item.statusId)) ||
                        isLockRestricted
                    "
                    text="No aplica"
                    @input="(evt) => updateApplicableFlag(item, evt)"
                  />
                </div>
                <div v-if="canShowSectionDate(item)" class="col-md-12">
                  <div class="row mt-4">
                    <div
                      v-if="canShowClassificationType(item) && !item.isExempted"
                      class="col-md-4"
                    >
                      <label class="color-gray-6 font-14">
                        Clasificación:
                      </label>
                      <div
                        v-if="!biddingRequestHasBeenDetermined"
                        class="mt-n2"
                      >
                        <validation-provider
                          v-if="documentIsStatusPending(item)"
                          v-slot="{ errors }"
                          rules="required"
                        >
                          <custom-drop-down
                            id="classificationType"
                            v-model="item.classificationType"
                            :clearable="false"
                            custom-error-msg="La clasificación es requerida."
                            :disabled="!documentIsStatusPending(item)"
                            :error="errors[0]"
                            fieldkey="id"
                            fieldname="name"
                            :options="providerInfo.classificationTypes"
                            placeholder="Seleccione"
                            @input="
                              onChangeClassificationTypeHandler(item, $event)
                            "
                          />
                        </validation-provider>
                        <div v-else class="color-black font-16">
                          {{ item.classificationType?.name | empty }}
                        </div>
                      </div>
                      <div v-else class="color-black font-16 mt-n2">
                        {{ item.classificationType?.name | empty }}
                      </div>
                    </div>
                    <div
                      v-if="
                        canShowLicenseSpecialtyType(item) && !item.isExempted
                      "
                      class="col-md-4"
                    >
                      <label class="color-gray-6 font-14">
                        Tipo de Licencia:
                      </label>
                      <div
                        v-if="!biddingRequestHasBeenDetermined"
                        class="mt-n2"
                      >
                        <validation-provider
                          v-if="documentIsStatusPending(item)"
                          v-slot="{ errors }"
                          rules="required"
                        >
                          <custom-drop-down
                            id="licenseSpecialtyType"
                            v-model="item.licenseSpecialtyType"
                            :clearable="false"
                            custom-error-msg="El tipo de licencia es requerido."
                            :disabled="!documentIsStatusPending(item)"
                            :error="errors[0]"
                            fieldkey="id"
                            fieldname="name"
                            :options="providerInfo.specialistSpecialtyTypes"
                            placeholder="Seleccione"
                            @input="
                              onChangeLicenseSpecialtyTypeHandler(item, $event)
                            "
                          />
                        </validation-provider>
                        <div v-else class="color-black font-16">
                          {{ item.licenseSpecialtyType?.name | empty }}
                        </div>
                      </div>
                      <div v-else class="color-black font-16 mt-n2">
                        {{ item.licenseSpecialtyType?.name | empty }}
                      </div>
                    </div>
                    <div
                      v-if="
                        canShowDocumentExpirationDate(item) && !item.isExempted
                      "
                      class="col-md-4"
                    >
                      <label class="color-gray-6 font-14">
                        Fecha de Vencimiento:
                      </label>
                      <div
                        v-if="!biddingRequestHasBeenDetermined"
                        class="mt-n2"
                      >
                        <validation-provider
                          v-if="documentIsStatusPending(item)"
                          v-slot="{ errors }"
                          rules="required"
                        >
                          <custom-date-picker
                            id="expirationDate"
                            v-model="item.documentExpirationDate"
                            :class-container="'w-100'"
                            custom-error-msg="La fecha de vencimiento es requerida."
                            :disabled="!documentIsStatusPending(item)"
                            :error="errors[0]"
                            format="dd/MMM./yyyy"
                            :min-date="currentDate"
                            placeholder="DD/MM/YYYY"
                            @input="
                              onChangeDocumentExpirationDateHandler(
                                item,
                                $event
                              )
                            "
                          />
                        </validation-provider>
                        <div v-else class="color-black font-16">
                          {{ item.documentExpirationDate | date }}
                        </div>
                      </div>
                      <div v-else class="color-black font-16 mt-n2">
                        {{ item.documentExpirationDate | date }}
                      </div>
                    </div>
                    <div
                      v-if="
                        canShowDocumentAppointmentDate(item) && !item.isExempted
                      "
                      class="col-md-4"
                    >
                      <label class="color-gray-6 font-14">
                        Fecha de Cita:
                      </label>
                      <div
                        v-if="
                          !biddingRequestHasBeenDetermined &&
                            documentIsStatusPending(item)
                        "
                        class="mt-n2"
                      >
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                        >
                          <custom-date-picker
                            id="appointmentDate"
                            v-model="item.documentAppointmentDate"
                            :class-container="'w-100'"
                            custom-error-msg="La fecha es requerida."
                            :disabled="!documentIsStatusPending(item)"
                            :error="errors[0]"
                            format="dd/MMM./yyyy"
                            :min-date="currentDate"
                            placeholder="DD/MM/YYYY"
                            @input="
                              onChangeDocumentAppointmentDateHandler(
                                item,
                                $event
                              )
                            "
                          />
                        </validation-provider>
                      </div>
                      <div v-else class="color-black font-16 mt-n2">
                        {{ item.documentAppointmentDate | date }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <template #edition>
              <div class="col-md-12 row pr-0">
                <!-- Document status history -->
                <div class="m-2 col-md-12 bg-white rounded">
                  <document-status-history
                    v-if="activeIndex != null"
                    :academic-year-id="academicYearId"
                    :company-id="companyId"
                    :contract-document-id="item.contractDocumentId"
                    :contract-document-type-id="item.contractDocumentTypeId"
                  />
                </div>
                <!-- Denied panel -->
                <div
                  v-if="item.deniedPanel.editting"
                  class="m-2 col-md-12 bg-white rounded align-items-center"
                >
                  <div class="rounded p-2">
                    <icon-view
                      class="p-1 rounded-circle"
                      icon="fas fa-times-circle"
                      icon-color="red"
                      icon-size="14px"
                      title="Razón para Denegar"
                    />

                    <div class="col-12 mt-3">
                      <label class="color-gray-6 font-14">
                        Razón para Denegar:
                      </label>
                      <validation-provider
                        :ref="'deniedReasonRef-' + index"
                        v-slot="{ errors }"
                        rules="required"
                      >
                        <custom-text-area
                          v-model="item.reason"
                          :count-classes="['float-right']"
                          custom-error-msg="La razón de denegación es requerida."
                          :error="errors[0]"
                          :maxlength="3000"
                          show-char-count
                        />
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row mt-5 pb-4">
                    <div class="col-12">
                      <action-button
                        class="float-right ml-2"
                        i="fas fa-save fa-lg"
                        text="Guardar"
                        variant="success"
                        @click="onActionItemDeniedHandler(item, index)"
                      />
                      <action-button
                        class="float-right"
                        i="fas fa-times-circle"
                        text="Cancelar"
                        variant="outline-danger"
                        @click="onActionItemDeniedCanceledHandler(item)"
                      />
                    </div>
                  </div>
                </div>
                <!-- Approve panel -->
                <div
                  v-if="item.approvePanel.editting"
                  class="m-2 col-md-12 bg-white rounded align-items-center"
                >
                  <div class="rounded p-2">
                    <icon-view
                      class="p-1 rounded-circle"
                      icon="fas fa-check-circle"
                      icon-color="green"
                      icon-size="14px"
                      title="Razón de aprobación"
                    />
                    <div class="col-12 mt-3">
                      <label class="color-gray-6 font-14">
                        Comentario:
                      </label>
                      <validation-provider :ref="'approveReasonRef-' + index">
                        <custom-text-area
                          v-model="item.reason"
                          :count-classes="['float-right']"
                          :maxlength="3000"
                          show-char-count
                        />
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row mt-5 pb-4">
                    <div class="col-12">
                      <action-button
                        class="float-right ml-2"
                        i="fas fa-save fa-lg"
                        text="Guardar"
                        variant="success"
                        @click="onActionItemApproveHandler(item)"
                      />
                      <action-button
                        class="float-right"
                        i="fas fa-times-circle"
                        text="Cancelar"
                        variant="outline-success"
                        @click="onActionItemApproveCanceledHandler(item)"
                      />
                    </div>
                  </div>
                </div>
                <!-- Replacement request panel -->
                <div
                  v-if="item.replacementRequestPanel.editting"
                  class="m-2 col-md-12 bg-white rounded align-items-center"
                >
                  <div class="rounded p-2">
                    <icon-view
                      class="p-1 rounded-circle"
                      icon="fas fa-arrow-from-right"
                      icon-color="#F3AF54"
                      icon-size="14px"
                      title="Razón de Solicitud de Reemplazo"
                    />

                    <div class="col-12 mt-3">
                      <label class="color-gray-6 font-14">Comentario:</label>
                      <validation-provider
                        :ref="'replacementRequestReasonRef-' + index"
                        v-slot="{ errors }"
                        rules="required"
                      >
                        <custom-text-area
                          id="textAreaReasonReplacementRequest"
                          v-model="item.reason"
                          :count-classes="['float-right']"
                          custom-error-msg="El comentario es requerido."
                          :error="errors[0]"
                          :maxlength="3000"
                          show-char-count
                        />
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row mt-5 pb-4">
                    <div class="col-12">
                      <action-button
                        id="actionBtnSaveReplacementRequest"
                        class="float-right ml-2"
                        i="fas fa-save fa-lg"
                        text="Guardar"
                        variant="success"
                        @click="
                          onActionItemReplacementRequestHandler(item, index)
                        "
                      />
                      <action-button
                        id="actionBtnSaveReplacementRequest"
                        class="float-right"
                        i="fas fa-times-circle"
                        text="Cancelar"
                        variant="outline-danger"
                        @click="
                          onActionItemReplacementRequestCanceledHandler(item)
                        "
                      />
                    </div>
                  </div>
                </div>
                <!-- Conditional approved panel -->
                <div
                  v-if="item.conditionalApprovedPanel.editting"
                  class="m-2 col-md-12 bg-white rounded align-items-center"
                >
                  <div class="rounded p-2">
                    <icon-view
                      class="p-1 rounded-circle"
                      icon="fas fa-check"
                      icon-color="#F3AF54"
                      icon-size="14px"
                      title="Razón de Aprobación Condicionado"
                    />
                    <div class="row">
                      <div class="col-md-2 col-sm-12 mt-3">
                        <validation-provider
                          :ref="'conditionalApprovedEndDateRef-' + index"
                          v-slot="{ errors }"
                          rules="required"
                        >
                          <label class="color-gray-6 font-14">
                            Fecha de Término:
                          </label>
                          <custom-date-picker
                            id="datePickerEndDateConditionalApproved"
                            v-model="item.documentEndDate"
                            :class-container="'w-100'"
                            :custom-error-msg="
                              'La fecha de término es requerida.'
                            "
                            :error="errors[0]"
                            format="dd/MMM./yyyy"
                            :min-date="currentDate"
                          />
                        </validation-provider>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 mt-3">
                        <label class="color-gray-6 font-14">Comentario:</label>
                        <validation-provider
                          :ref="'conditionalApprovedReasonRef-' + index"
                          v-slot="{ errors }"
                          rules="required"
                        >
                          <custom-text-area
                            id="textAreaReasonConditionalApproved"
                            v-model="item.reason"
                            :count-classes="['float-right']"
                            custom-error-msg="El comentario es requerido."
                            :error="errors[0]"
                            :maxlength="3000"
                            show-char-count
                          />
                        </validation-provider>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-5 pb-4">
                    <div class="col-12">
                      <action-button
                        id="actionBtnSaveConditionalApproved"
                        class="float-right ml-2"
                        i="fas fa-save fa-lg"
                        text="Guardar"
                        variant="success"
                        @click="
                          onActionItemConditionalApprovedHandler(item, index)
                        "
                      />
                      <action-button
                        id="actionBtnCancelConditionalApproved"
                        class="float-right"
                        i="fas fa-times-circle"
                        text="Cancelar"
                        variant="outline-danger"
                        @click="
                          onActionItemConditionalApprovedCanceledHandler(item)
                        "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </custom-callout>
          <div v-if="canShowDocumentAccuracy(item)" class="row mx-auto">
            <div class="col-12 bg-secondary-41 py-2 rounded-bottom">
              <div class="d-flex align-items-center">
                <em class="fa fa-bell-exclamation font-18 color-secondary-40" />
                <div class="font-14 font-weight-normal color-secondary-40 ml-2">
                  {{ accuracyMessage(item) }}
                </div>
              </div>
            </div>
          </div>
          <custom-error
            v-if="
              item.documentExpirationDate != null &&
                Date.parse(item.documentExpirationDate) < new Date() &&
                !item.isExempted
            "
            class="mt-0"
            message="El documento está vencido."
            variant="border"
          />
        </div>
        <validation-provider
          v-slot="{ errors }"
          :rules="{ required: hasRequiredDocuments }"
        >
          <custom-error
            v-if="errors[0]"
            class="mt-2"
            message="Favor subir todos los documentos requeridos en sistema."
            variant="no-border"
          />
        </validation-provider>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import objectToFormData from 'object-to-formdata';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import PageHeader from 'PageHeader';
import SectionTitle from 'SectionTitle';
import CustomCallout from 'custom-callout';
import DropDown from 'dropdown';
import CustomBalloon from 'custom-balloon';
import CustomFileInput from 'CustomFileInput';
import CustomError from 'custom-error';
import CustomDropDown from 'custom-drop-down';
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';
import IconView from 'icon-view';
import CustomDatePicker from 'custom-date-picker';
import CustomResultNotFound from 'custom-result-not-found';
import CheckBox from 'CheckBox';
import {
  ProviderHeaderInfo,
  BiddingRequestDetermination,
  DocumentStatusHistory,
  DocumentStatusBar,
  LocationsSection,
  PublicOfficialsSection,
  ServicesToOfferSection,
} from './components';
import {
  getContractRequiredDocuments as _getContractRequiredDocuments,
  getCompanyHeaderInfo as _getCompanyHeaderInfo,
  saveContractDocument as _saveContractDocument,
  replacecontractdocument as _replacecontractdocument,
  deleteContractDocument as _deleteContractDocument,
  submitContractDocuments as _submitContractDocuments,
  updateDocumentExpirationDate as _updateDocumentExpirationDate,
  updateDocumentAppointmentDate as _updateDocumentAppointmentDate,
  updateDocumentClassificationType as _updateDocumentClassificationType,
  updateDocumentLicenseSpecialtyType as _updateDocumentLicenseSpecialtyType,
  updateDocumentExemptionFlag as _updateDocumentExemptionFlag,
  lockProvider as _lockProvider,
  unlockProvider as _unlockProvider,
} from '@/services/provider/provider.api.js';
import {
  getBiddingAvailableAcademicYears as _getBiddingAvailableAcademicYears,
  saveBiddingRequest as _saveBiddingRequest,
  determineContractDocument as _determineContractDocument,
  goBackStatusContractDocument as _goBackStatusContractDocument,
  validatesubmittedsections as _validatesubmittedsections,
} from '@/services/provider/provider-bidding.api.js';
import { downloadDocumentByAttachmentId as _downloadDocumentByAttachmentId } from '@/services/common/document.api.js';
import providerContractDocumentStatus from '@/utils/constants/providerContractDocumentStatus.js';
import { contractDocumentTypes } from '@/utils/constants/contractDocumentTypes.js';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import biddingRequestStatus from '@/utils/constants/biddingRequestStatus.js';
import { getSsn as _getSsn } from '@/services/provider/provider.api.js';
import {
  getGroupNameByType,
  groupTypes,
} from '@/utils/constants/contractDocumentGroupTypes.js';
import { classificationTypes } from '@/utils/constants/contractDocumentClassificationTypes.js';
import specialistTypes from '@/utils/constants/specialtyTypes';
import {
  getSections as _getSections,
  getQuestions as _getQuestions,
  updateStatus as _updateStatus,
  getMunicipalities as _getMunicipalities,
  getSectionStatusHistory as _getSectionStatusHistory,
} from '@/services/provider/provider-question.js';
import providerQuestionSection from '@/utils/constants/providerQuestionSection';
import providerProfileStates from '@/utils/constants/ProviderProfileStates';
import ExecutiveSummary from './components/ExecutiveSummary.vue';
import FinancialResourcesBilling from './components/FinancialResourcesBilling.vue';
import GeographicAreas from './components/GeographicAreas.vue';
import { getByParameterName } from '@/services/common/sysparameter.api';
import providerTypes from '@/utils/constants/providerTypes.js';
import { CustomTab, CustomTabItem } from 'custom-tabs';
import ProfileSectionHistory from './components/ProfileSectionHistory.vue';

const PROVIDER_CONTRACT_DOCUMENT_ROUTE_NAME = 'ProviderContractDocument';
const PERMISSION_UNIQUE_DOC_TYPE = 97;

export default {
  name: 'ProviderContractDocument',
  mixins: [alertMixin],
  components: {
    ValidationObserver,
    ValidationProvider,
    PageHeader,
    SectionTitle,
    CustomCallout,
    DropDown,
    CustomBalloon,
    CustomFileInput,
    CustomError,
    CustomDropDown,
    ActionButton,
    CustomResultNotFound,
    ProviderHeaderInfo,
    BiddingRequestDetermination,
    CustomTextArea,
    IconView,
    CustomDatePicker,
    DocumentStatusHistory,
    DocumentStatusBar,
    CheckBox,
    ExecutiveSummary,
    LocationsSection,
    FinancialResourcesBilling,
    PublicOfficialsSection,
    GeographicAreas,
    ServicesToOfferSection,
    CustomTab,
    CustomTabItem,
    ProfileSectionHistory,
  },
  data: () => ({
    providerQuestionSection,
    providerInfo: {},
    selectedItem: {},
    documents: [],
    academicYears: [],
    statesOptions: [],
    locations: [],
    model: {
      academicYear: null,
    },
    isOpenRequestDetermination: null,
    requestDeterminationStatusId: null,
    APPROVED: providerContractDocumentStatus.Approved,
    APPROVEDSQE: providerProfileStates.Approved,
    CONDITIONALAPPROVEDSQE: providerProfileStates.ConditionalApproved,
    REPLACEMENTREQUESTEDQE: providerProfileStates.ReplacementRequest,
    isSsnMasked: true,
    activeIndex: null,
    isVisibleES: false,
    isVisibleES_DeniedPanel: false,
    isVisibleSQE_DeniedPanel: false,
    isVisibleFRB_DeniedPanel: false,
    isVisibleGA_DeniedPanel: false,
    isVisibleLocation_DeniedPanel: false,
    isVisiblePO_DeniedPanel: false,
    isVisibleOS_DeniedPanel: false,

    isVisibleES_ApprovePanel: false,
    isVisibleSQE_ApprovePanel: false,
    isVisibleFRB_ApprovePanel: false,
    isVisibleGA_ApprovePanel: false,
    isVisibleLocation_ApprovePanel: false,
    isVisiblePO_ApprovePanel: false,
    isVisibleOS_ApprovePanel: false,

    isVisibleSQE: false,
    isVisibleFRB: false,
    isVisibleGA: false,
    isVisibleLocation: false,
    isVisibleLocation_ConditionalApprovePanel: false,
    isVisibleLocation_ReplacementPanel: false,
    isVisiblePO: false,
    isVisibleOS: false,

    sectionsProviderProfile: [],
    sectionInfoSQE: {},
    sectionInfoES: {},
    sectionInfoFRB: {},
    sectionInfoPO: {},
    sectionInfoGA: {},
    questionsSQE: [],
    questionsES: [],
    questionsFRB: [],
    questionsPO: [],
    sectionInfoLocation: {},
    expiringLocationsAlert: [],
    sectionInfoOS: {},
    optionsGA: [],
    providerProfileEnabled: false,
    sectionStatusHistoryMap: {
      executiveSummary: [],
      location: [],
      supervisionQualityEthicalSection: [],
      financialResourcesBilling: [],
      publicOfficialsSection: [],
      servicesToOffer: [],
      geographicAreas: [],
    },
    isUniquePermissionInProviderRequestDocumentsEnabled: undefined,
  }),
  computed: {
    reverseSectionMap() {
      return Object.entries(providerQuestionSection).reduce(
        (acc, [key, id]) => {
          acc[id] = key.charAt(0).toLowerCase() + key.slice(1);
          return acc;
        },
        {}
      );
    },
    hasUnMaskSSNPermission() {
      return this.userHasPermissions('rempro.providers.display.ssn');
    },
    headerConfig() {
      return {
        title: 'Proveedor',
        icon: 'fas fa-user-tie',
        routes: ['Inicio', 'Proveedor'],
      };
    },
    getColorStatus() {
      return (statusId) => {
        switch (statusId) {
          case providerContractDocumentStatus.Pending:
            return 'secondary-44';
          case providerContractDocumentStatus.Submitted:
            return 'yellow';
          case providerContractDocumentStatus.Approved:
            return 'green-light';
          case providerContractDocumentStatus.Denied:
            return 'brown';
          case providerContractDocumentStatus.ConditionalApproved:
            return 'orange-light';
          case providerContractDocumentStatus.ReplacementRequest:
            return 'violet';
          default:
            return null;
        }
      };
    },
    getGroupType() {
      return (typeId) => getGroupNameByType(typeId);
    },
    requestDeterminationActionItems() {
      return [
        {
          label: 'Aprobar',
          icon: 'fas fa-check color-green',
          click: () =>
            this.onOpenRequestDeterminationHandler(
              biddingRequestStatus.Approved
            ),
        },
        {
          label: 'Denegar',
          icon: 'fas fa-times-circle color-primary-4',
          click: () =>
            this.onOpenRequestDeterminationHandler(biddingRequestStatus.Denied),
        },
      ];
    },
    hasRequiredDocuments() {
      return !this.documents.every((x) => x.documentId || x.isExempted);
    },
    companyId() {
      return this.$route.params?.companyId;
    },
    academicYearId() {
      return this.$route.params?.academicYearId;
    },
    currentAcademicYearId() {
      return this.providerInfo?.academicYearId;
    },
    isPending() {
      return (statusId) => {
        return statusId === providerContractDocumentStatus.Pending;
      };
    },
    isPendingSQE() {
      return (statusId) => {
        return statusId === providerProfileStates.Pending;
      };
    },
    isSubmitted() {
      return (statusId) => {
        return statusId === providerContractDocumentStatus.Submitted;
      };
    },
    isSubmittedSQE() {
      return (statusId) => {
        return statusId === providerProfileStates.Submitted;
      };
    },
    isApproved() {
      return (statusId) => {
        return statusId === providerContractDocumentStatus.Approved;
      };
    },
    isApprovedSQE() {
      return (statusId) => {
        return statusId === providerProfileStates.Approved;
      };
    },
    isConditionalApproved() {
      return (statusId) => {
        return statusId === providerContractDocumentStatus.ConditionalApproved;
      };
    },
    isConditionalApprovedSQE() {
      return (statusId) => {
        return statusId === providerProfileStates.ConditionalApproved;
      };
    },
    isReplacementRequestSQE() {
      return (statusId) => {
        return statusId === providerProfileStates.ReplacementRequest;
      };
    },
    isReplacementRequest() {
      return (statusId) => {
        return statusId === providerContractDocumentStatus.ReplacementRequest;
      };
    },
    isDenied() {
      return (statusId) => {
        return statusId === providerContractDocumentStatus.Denied;
      };
    },
    isDeniedSQE() {
      return (statusId) => {
        return statusId === providerProfileStates.Denied;
      };
    },
    denied() {
      return providerProfileStates.Denied;
    },
    approved() {
      return providerProfileStates.Approved;
    },
    canUpload() {
      return (item) => {
        return (
          ((this.isPending(item.statusId) && !item.documentId) ||
            (item.documentId &&
              (this.isDenied(item.statusId) ||
                this.isConditionalApproved(item.statusId) ||
                this.isReplacementRequest(item.statusId)))) &&
          !this.biddingRequestHasBeenDetermined &&
          !this.isLockRestricted
        );
      };
    },
    canDownload() {
      return (item) => {
        return (
          (this.isSubmitted(item.statusId) ||
            this.isApproved(item.statusId) ||
            this.isDenied(item.statusId) ||
            this.isReplacementRequest(item.statusId) ||
            this.isConditionalApproved(item.statusId) ||
            this.biddingRequestHasBeenDetermined) &&
          item.filename
        );
      };
    },
    canReplace() {
      return (item) => {
        return (
          (this.isSubmitted(item.statusId) ||
            this.isApproved(item.statusId) ||
            this.biddingRequestHasBeenDetermined) &&
          item.filename &&
          this.hasReplaceDocumentPermission &&
          !this.isLockRestricted
        );
      };
    },
    canApproveDeny() {
      return (statusId) => {
        return (
          this.isSubmitted(statusId) &&
          this.hascontractDocDeterminatePermission &&
          !this.biddingRequestHasBeenDetermined &&
          !this.isLockRestricted
        );
      };
    },
    canApproveDenySQE() {
      return (statusId) => {
        return (
          this.isSubmittedSQE(statusId) &&
          this.hascontractDocDeterminatePermission &&
          !this.isLockRestricted
        );
      };
    },
    canReplacementRequest() {
      return (statusId) => {
        return (
          (this.isApproved(statusId) || this.isConditionalApproved(statusId)) &&
          this.hascontractDocDeterminatePermission &&
          !this.isLockRestricted
        );
      };
    },
    canReplacementRequestSQE() {
      return (statusId) => {
        return (
          (this.isApprovedSQE(statusId) ||
            this.isConditionalApprovedSQE(statusId)) &&
          this.hascontractDocDeterminatePermission &&
          !this.isLockRestricted
        );
      };
    },
    canConditionalApprove() {
      return (item) => {
        return (
          this.isSubmitted(item.statusId) &&
          (item.classificationType?.id == classificationTypes.appointment ||
            this.hasExpirationDate(item.documentExpirationDate)) &&
          this.hasAllowedDocumentType(item.contractDocumentTypeId) &&
          this.hascontractDocDeterminatePermission &&
          !this.isLockRestricted
        );
      };
    },
    canGoBack() {
      return (statusId) => {
        return (
          (this.isApproved(statusId) ||
            this.isDenied(statusId) ||
            this.isReplacementRequest(statusId) ||
            this.isConditionalApproved(statusId)) &&
          this.hasGoBackStatusPermission &&
          !this.biddingRequestHasBeenDetermined &&
          !this.isLockRestricted
        );
      };
    },
    canGoBackSQE() {
      return (statusId) => {
        return (
          (this.isApprovedSQE(statusId) ||
            this.isDeniedSQE(statusId) ||
            this.isConditionalApproved(statusId) ||
            this.isReplacementRequestSQE(statusId)) &&
          this.hasGoBackStatusPermission &&
          !this.isLockRestricted
        );
      };
    },
    canEditSQE() {
      return (statusId) => {
        return (
          (this.isDeniedSQE(statusId) ||
            this.isReplacementRequestSQE(statusId)) &&
          !this.isLockRestricted
        );
      };
    },
    allNotSubmitted() {
      return this.documents.every(
        (x) =>
          x.statusId !== providerContractDocumentStatus.Submitted ||
          x.isExempted
      );
    },
    hasAllPending() {
      return this.documents.every(
        (x) => x.statusId === providerContractDocumentStatus.Pending
      );
    },
    hasNotPending() {
      return this.documents.every(
        (x) => x.statusId !== providerContractDocumentStatus.Pending
      );
    },
    hasNotDenied() {
      return this.documents.every(
        (x) => x.statusId !== providerContractDocumentStatus.Denied
      );
    },
    hasExpirationDate() {
      return (expirationDate) => {
        return (
          (expirationDate instanceof Date && !isNaN(expirationDate)) ||
          !isNaN(Date.parse(expirationDate))
        );
      };
    },
    hasAllowedDocumentType() {
      return (documentTypeId) => {
        return [
          contractDocumentTypes.permisoÚnico,
          contractDocumentTypes.certificaciónPRBackgroundCheckProgram,
        ].includes(documentTypeId);
      };
    },
    existBiddingRequest() {
      return Object.values(this.providerInfo?.biddingInfo ?? {}).length > 0;
    },
    biddingAcademicYearName() {
      return this.providerInfo?.biddingInfo.academicYearName;
    },
    biddingAcademicYearId() {
      return this.providerInfo?.biddingInfo.academicYearId;
    },
    biddingRequestNumber() {
      return this.providerInfo?.biddingInfo?.requestNumber;
    },
    isBiddingRequestPending() {
      return (
        this.providerInfo?.biddingInfo?.statusId ===
          biddingRequestStatus.Pending || this.biddingRequestHasBeenDetermined
      );
    },
    biddingRequestHasBeenDetermined() {
      const requestHasBeenDetermined = this.providerInfo?.biddingInfo
        ?.requestHasBeenDetermined;
      const allDocumentApproved = this.documents.every(
        (x) => x.statusId === providerContractDocumentStatus.Approved
      );

      if (!this.providerProfileEnabled) {
        return this.providerInfo?.biddingInfo?.statusId ==
          biddingRequestStatus.Approved
          ? allDocumentApproved
          : requestHasBeenDetermined;
      } else {
        const sectionStatus = [
          providerProfileStates.Approved,
          providerProfileStates.ConditionalApproved,
        ];

        const allSectionsApproved = this.sectionsProviderProfile.every(
          (section) => sectionStatus.includes(section.statusId)
        );
        if (!allSectionsApproved) {
          return false;
        }

        const today = new Date();
        const hasValidConditionalApprovedSections = this.sectionsProviderProfile.every(
          (section) => {
            if (
              section.statusId === providerProfileStates.ConditionalApproved
            ) {
              const statusEndDate = new Date(section.statusEndDate);
              return statusEndDate > today;
            }
            return true;
          }
        );
        if (!hasValidConditionalApprovedSections) {
          return false;
        }

        return (
          allSectionsApproved && allDocumentApproved && requestHasBeenDetermined
        );
      }
    },
    canSubmit() {
      return (
        ((this.existBiddingRequest &&
          !this.biddingRequestHasBeenDetermined &&
          this.hasNotDenied &&
          this.hasPendingAndRequired) ||
          this.hasPendingDocuments) &&
        !this.isLockRestricted
      );
    },
    hasPendingDocuments() {
      return this.documents.some(
        (x) => x.statusId === providerContractDocumentStatus.Pending
      );
    },
    hasPendingAndRequired() {
      return this.documents.some(
        (x) =>
          x.statusId === providerContractDocumentStatus.Pending &&
          ((!x.isExempted &&
            this.isApplicableDocument(x.contractDocumentTypeId)) ||
            !this.isApplicableDocument(x.contractDocumentTypeId))
      );
    },
    hascontractDocDeterminatePermission() {
      return this.userHasPermissions(
        'rempro.providers.determinate.contractdoc'
      );
    },
    hasGoBackStatusPermission() {
      return this.userHasPermissions(
        'rempro.providers.determinate.gobackstatus'
      );
    },
    hasReplaceDocumentPermission() {
      return this.userHasPermissions('rempro.replaceproviderdocument');
    },
    hasViewGroupPermission() {
      return this.userHasPermissions('rempro.providers.view.grouptype');
    },
    currentDate() {
      let date = new Date();
      date.setDate(date.getDate() - 1);
      return date;
    },
    getDate() {
      return new Date();
    },
    canShowSectionDate() {
      return (item) => {
        return (
          this.canShowClassificationType(item) ||
          this.canShowLicenseSpecialtyType(item) ||
          this.canShowDocumentExpirationDate(item)
        );
      };
    },
    canShowDocumentExpirationDate() {
      return (item) => {
        if (
          item.licenseSpecialtyType?.id === specialistTypes.GradeCertification
        ) {
          return false;
        }

        if (this.canShowClassificationType(item)) {
          return (
            item.classificationType?.id === classificationTypes.certification
          );
        }
        return (
          !!(
            this.biddingRequestHasBeenDetermined && item.documentExpirationDate
          ) ||
          (!this.biddingRequestHasBeenDetermined &&
            item.requiredExpirationDateFlag)
        );
      };
    },
    canShowDocumentAppointmentDate() {
      return (item) => {
        return (
          this.canShowClassificationType(item) &&
          item.classificationType?.id === classificationTypes.appointment
        );
      };
    },
    canShowClassificationType() {
      return (item) => {
        return (
          item.contractDocumentTypeId ===
            contractDocumentTypes.certificaciónPRBackgroundCheckProgram &&
          (!!(
            this.biddingRequestHasBeenDetermined &&
            (item.documentExpirationDate || item.documentAppointmentDate)
          ) ||
            (!this.biddingRequestHasBeenDetermined &&
              item.requiredExpirationDateFlag))
        );
      };
    },
    canShowLicenseSpecialtyType() {
      return (item) => {
        return (
          item.contractDocumentTypeId ===
            contractDocumentTypes.licenciaCertificadoProfesional &&
          (!!(
            this.biddingRequestHasBeenDetermined &&
            (item.documentExpirationDate || item.documentAppointmentDate)
          ) ||
            (!this.biddingRequestHasBeenDetermined &&
              item.requiredExpirationDateFlag))
        );
      };
    },
    canShowStatusBar() {
      return (
        this.userHasPermissions('rempro.providers.display.statusbar') &&
        this.documents.length > 0
      );
    },
    isApplicableDocument() {
      return (typeId) => {
        const notApplicableDocuments = [
          contractDocumentTypes.certificadoColegiacion,
          contractDocumentTypes.documentoColegiacion,
          contractDocumentTypes.certificadoOColegiacion,
          contractDocumentTypes.licenciaCertificadoProfesional,
          contractDocumentTypes.licenciaProfesionalEnfermera,
        ];

        return notApplicableDocuments.includes(typeId);
      };
    },
    documentIsStatusPending() {
      return (item) => {
        return item.statusId === providerContractDocumentStatus.Pending;
      };
    },
    isDeniedDocument() {
      return (item) => {
        return item.statusId === providerContractDocumentStatus.Denied;
      };
    },
    accuracyMessage() {
      return ({ validatorAccuracy }) => {
        const accuracy = isNaN(validatorAccuracy)
          ? null
          : validatorAccuracy * 100;
        return `La fiabilidad del documento cuenta con un ${accuracy}%.`;
      };
    },
    canShowDocumentAccuracy() {
      return ({ validatorAccuracy }) =>
        this.userHasPermissions(
          'rempro.formrecognizer.alert.reliability.view'
        ) && validatorAccuracy !== null;
    },
    showDeterminationActions() {
      let userCanDetermine = this.userHasPermissions(
        'rempro.providers.determinate.biddingrequest'
      );

      return (
        userCanDetermine &&
        this.existBiddingRequest &&
        !this.biddingRequestHasBeenDetermined &&
        !this.isLockRestricted
      );
    },
    providerType() {
      if (
        this.providerInfo?.providerTypeId === providerTypes.Company &&
        !this.providerInfo?.isIncorporatedCompany
      ) {
        return providerTypes.Individual;
      }
      return this.providerInfo?.providerTypeId;
    },
    statusAlertLocation() {
      if (this.sectionInfoLocation.statusId === providerProfileStates.Denied)
        return this.sectionInfoLocation.denialComment;
      const statuses = [
        providerProfileStates.ConditionalApproved,
        providerProfileStates.ReplacementRequest,
      ];
      if (statuses.includes(this.sectionInfoLocation.statusId))
        return this.sectionInfoLocation.statusComment;
      return null;
    },
    isLocked() {
      return this.providerInfo?.biddingInfo?.isLocked ?? false;
    },
    isLockedByCurrentUser() {
      return this.providerInfo?.biddingInfo?.isLockedByCurrentUser ?? false;
    },
    isLockRestricted() {
      return this.isLocked && !this.isLockedByCurrentUser;
    },
    canLock() {
      return this.userHasPermissions('rempro.providers.lock') && !this.isLocked;
    },
  },
  async mounted() {
    await this.getCompanyHeaderInfo(this.academicYearId);
    await this.getUniquePermissionInProviderRequestDocumentsParameter();

    if (this.existBiddingRequest) {
      await this.getContractRequiredDocuments();
    } else {
      await this.getBiddingAvailableAcademicYears();
    }
    await this.getProviderProfileSysParameter();

    if (this.providerProfileEnabled) {
      await this.getSectionsProviderProfile();
      await this.getQuestionsSQE();
      await this.getQuestionsES();
      await this.getQuestionsFRB();
      await this.getQuestionsPO();
      await this.getOptionsGA();
    }
  },
  methods: {
    async onToggleSSNMaskHandler() {
      if (!this.hasUnMaskSSNPermission) return;

      const { data: response } = await _getSsn(
        this.companyId,
        !this.isSsnMasked
      );
      if (response) {
        this.providerInfo.ssn = response;
        this.isSsnMasked = !this.isSsnMasked;
      }
    },
    async getContractRequiredDocuments() {
      let documents = (
        await _getContractRequiredDocuments(
          this.companyId,
          this.biddingAcademicYearId
        )
      ).data;
      if (this.isUniquePermissionInProviderRequestDocumentsEnabled) {
        documents = documents.filter(
          (x) => x.contractDocumentTypeId !== PERMISSION_UNIQUE_DOC_TYPE
        );
      }
      this.documents = documents.map((item) => ({
        ...item,
        deniedPanel: {
          editting: false,
        },
        approvePanel: {
          editting: false,
        },
        replacementRequestPanel: {
          editting: false,
        },
        conditionalApprovedPanel: {
          editting: false,
        },
      }));
    },
    async getCompanyHeaderInfo(academicYearId = null) {
      this.providerInfo = (
        await _getCompanyHeaderInfo(this.companyId, academicYearId)
      ).data;
    },
    async onTermsModalHandler(itemIndex) {
      this.$refs.fileInputRef[itemIndex].$refs.fileuploadRef.click();
    },
    async onUploadFileHandler(file, item) {
      if (file) {
        item.attachment = file;
        // En caso de tener un documento denegado que tiene el flag isExempted true, esto para evitar que se ejecute el @input del checkbox
        if (this.isDeniedDocument(item) && item.isExempted) {
          item.isExempted = false;
        }
        await this.saveContractDocument();
        await this.$forceUpdate();
      }
    },
    async onReplaceFileHandler(file, item) {
      if (file) {
        item.attachment = file;
        await this.replaceDocument();
        await this.$forceUpdate();
      }
    },
    async onRemoveHandler({ contractDocumentId }) {
      if (contractDocumentId) {
        const { data: result } = await _deleteContractDocument(
          contractDocumentId
        ).catch((err) => {
          this.ShowToast(
            'Alerta',
            err.response.data.message || 'error',
            'error'
          );
        });
        if (result) {
          await this.getContractRequiredDocuments();
        }
      }
    },
    async onNoApplyRemoveHandler(item, evt) {
      if (item.contractDocumentId) {
        const { data: result } = await _deleteContractDocument(
          item.contractDocumentId
        ).catch((err) => {
          this.ShowToast(
            'Alerta',
            err.response.data.message || 'error',
            'error'
          );
        });
        if (result) {
          await this.updateApplicableFlag(item, evt);
          await this.getContractRequiredDocuments();
        }
      }
    },
    async onSubmitHandler() {
      try {
        const companyId = this.$route.params?.companyId;
        const academicYearId = this.$route.params?.academicYearId;

        if (this.providerProfileEnabled) {
          await _validatesubmittedsections(companyId, academicYearId);
        }

        const isValid = await this.$refs.documentRef.validate();
        if (!isValid) {
          this.ShowToast(
            'Alerta',
            'Favor subir todos los documentos requeridos en sistema.',
            'error'
          );
          return;
        }

        const contractDocuments = this.documents
          .filter((x) => x.statusId === providerContractDocumentStatus.Pending)
          .map((s) => ({
            documentId: s.documentId,
            contractDocumentId: s.contractDocumentId,
            contractDocumentTypeId: s.contractDocumentTypeId,
            isExempted: s.isExempted,
          }));

        const { data: validationResult } = await _submitContractDocuments({
          contractDocuments,
          companyId,
          academicYearId,
        });

        if (
          validationResult &&
          validationResult.some(
            (x) =>
              x.isExpirationDateRequired &&
              !x.isValidExpirationDate &&
              x.isProcessedByAI
          )
        ) {
          const invalidatedDocumentTypes = validationResult
            .filter(
              (x) =>
                x.isExpirationDateRequired &&
                !x.isValidExpirationDate &&
                x.isProcessedByAI
            )
            .map((item) => item.contractDocumentTypeId);

          const documentTypesInvalided = this.documents
            .filter((item) =>
              invalidatedDocumentTypes.includes(item.contractDocumentTypeId)
            )
            .map((item) => item.documentTypeName)
            .join(', ');

          const answer = await this.ShowCancelModal(
            'Confirmación',
            `Se identificó que la fecha de vencimiento no coincide con la fecha documentada en sistema para el(los) documento(s) <b>${documentTypesInvalided}</b>. ¿Está seguro(a) que desea someter el(los) documento(s)?`,
            'Sí',
            'No'
          );
          if (!answer) return;
        }

        var submissionContractDocumentIds = contractDocuments.map(
          (document) => ({
            ...document,
            isSubmittingForm: true,
          })
        );

        const { data: submissionResult } = await _submitContractDocuments({
          contractDocuments: submissionContractDocumentIds,
          companyId,
          academicYearId,
        });

        if (submissionResult) {
          this.ShowToast(
            'Proceso Exitoso',
            'Los documentos del proveedor han sido sometidos exitosamente.',
            'success'
          );
          await this.getContractRequiredDocuments();
        }
      } catch (err) {
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error');
      }
    },
    async replaceDocument() {
      const companyId = this.$route.params?.companyId;
      const doc = this.documents.find((x) => x.attachment);

      if (companyId && doc) {
        const payload = objectToFormData(
          {
            companyId,
            contractDocumentTypeId: doc.contractDocumentTypeId,
            academicYearId: this.academicYearId,
            statusId: doc.statusId,
            file: doc.attachment,
            documentId: doc.documentId,
          },
          { indices: true, nullsAsUndefineds: true }
        );

        await _replacecontractdocument(payload);
        await this.getContractRequiredDocuments();
      }
    },
    async saveContractDocument() {
      const companyId = this.$route.params?.companyId;
      const doc = this.documents.find((x) => x.attachment);

      if (companyId && doc) {
        const payload = objectToFormData(
          {
            companyId,
            contractDocumentTypeId: doc.contractDocumentTypeId,
            academicYearId: this.academicYearId,
            statusId: doc.statusId,
            file: doc.attachment,
          },
          { indices: true, nullsAsUndefineds: true }
        );

        await _saveContractDocument(payload);
        await this.getContractRequiredDocuments();
      }
    },
    onDownloadHandler({ documentId }) {
      if (documentId) {
        _downloadDocumentByAttachmentId(documentId).catch((err) => {
          this.ShowToast(
            'Alerta',
            err.response.data.message || 'error',
            'error'
          );
        });
      }
    },
    async getBiddingAvailableAcademicYears() {
      this.academicYears = (
        await _getBiddingAvailableAcademicYears(this.companyId)
      ).data;
    },
    async onSaveBiddingHandler() {
      const isValid = await this.$refs.biddingFormRef.validate();
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }

      const { data } = await _saveBiddingRequest(
        this.model.academicYear?.id,
        this.companyId
      ).catch((error) => {
        const message = error?.response?.data?.message ?? error.message;
        this.ShowToast('Alerta', `${message}`, 'error');
        return { data: false };
      });

      if (data)
        this.ShowToast(
          'Proceso Exitoso',
          'La solicitud ha sido creada exitosamente.',
          'success'
        );

      this.$router.replace({
        name: PROVIDER_CONTRACT_DOCUMENT_ROUTE_NAME,
        params: {
          companyId: this.companyId,
          academicYearId: this.model.academicYear?.id,
        },
      });

      await this.getCompanyHeaderInfo(this.model.academicYear?.id);
      await this.getContractRequiredDocuments();
      await this.getProviderProfileSysParameter();
      if (this.providerProfileEnabled) {
        await this.getSectionsProviderProfile();
      }
    },
    async onOpenRequestDeterminationHandler(statusId) {
      if (!this.providerProfileEnabled) {
        if (!this.allNotSubmitted) {
          this.ShowToast(
            'Alerta',
            'No es posible aprobar la solicitud ya que cuenta con documentos en estatus sometido.',
            'error'
          );
          return;
        }

        if (
          statusId === biddingRequestStatus.Approved &&
          (!this.hasNotPending || !this.hasNotDenied)
        ) {
          this.ShowToast(
            'Alerta',
            'No es posible aprobar la solicitud ya que cuenta con documentos en estatus pendiente de someter.',
            'error'
          );
          return;
        }

        //validated required fields
        const isValid = await this.$refs.documentRef.validate();
        if (!isValid) {
          this.ShowToast(
            'Alerta',
            'Favor completar la información solicitada.',
            'error'
          );
          return;
        }
      }
      this.requestDeterminationStatusId = statusId;
      this.isOpenRequestDetermination = true;
    },
    onCancelRequestDeterminationHandler() {
      this.requestDeterminationStatusId = null;
      this.isOpenRequestDetermination = null;
    },
    async onSavedRequestDeterminationHandler() {
      this.onCancelRequestDeterminationHandler();
      await this.getCompanyHeaderInfo(this.academicYearId);
      await this.getContractRequiredDocuments();
    },
    async onActionItemsHandler(item, status) {
      const options = {
        [providerContractDocumentStatus.Approved]: ['aprobar el', 'aprobado'],
        [providerContractDocumentStatus.Denied]: ['denegar el', 'denegado'],
        [providerContractDocumentStatus.ReplacementRequest]: [
          'Solicitar Reemplazo del',
          'solicitado para reemplazo',
        ],
        [providerContractDocumentStatus.ConditionalApproved]: [
          'aprobar condicionado el',
          'aprobado condicionado',
        ],
      };

      if (status != providerContractDocumentStatus.Approved) {
        const answer = await this.ShowCancelModal(
          'Determinación',
          `¿Está seguro(a) que desea ${options[status][0]} documento ${item.documentTypeName}?`,
          'Sí',
          'No'
        );
        if (!answer) return;
      }

      await _determineContractDocument({
        contractDocumentId: item.contractDocumentId,
        status: status,
        reason: item.reason,
        biddingRequestNumber: this.biddingRequestNumber,
        documentEndDate: item.documentEndDate,
      }).then(() => {
        this.ShowToast(
          `Confirmación`,
          `El documento ha sido ${options[status][1]} exitosamente.`,
          'success'
        );
      });
      await this.getContractRequiredDocuments();
    },
    async onActionItemsHandlerSQE(item, status) {
      const options = {
        [providerProfileStates.Approved]: ['aprobar', 'aprobado'],
        [providerProfileStates.Denied]: ['denegar', 'denegado'],
      };

      const answer = await this.ShowCancelModal(
        'Determinación',
        `¿Está seguro(a) que desea ${options[status][0]}?`,
        'Sí',
        'No'
      );
      if (!answer) return;

      const payload = {
        sectionId: item.id,
        providerId: +this.companyId,
        academicYearId: this.biddingAcademicYearId,
        statusId: status,
      };

      const { data: response } = await _updateStatus(payload);
      if (response) {
        this.ShowToast(
          'Confirmación',
          `El estatus ha sido cambiado a ${options[status][1]} exitosamente.`,
          'success'
        );
        await this.getSectionsProviderProfile();
        await this.onTabClick(item.id);
      } else {
        this.ShowToast('Error', response?.data?.message || 'error', 'error');
      }
    },
    async onApproveDenyLocationHandler(status) {
      const options = {
        [providerProfileStates.Approved]: ['aprobar', 'aprobado'],
        [providerProfileStates.Denied]: ['denegar', 'denegado'],
      };

      const answer = await this.ShowCancelModal(
        'Determinación',
        `¿Está seguro(a) que desea ${options[status][0]}?`,
        'Sí',
        'No'
      );
      if (!answer) return;

      const payload = {
        sectionId: providerQuestionSection.Location,
        providerId: this.companyId,
        academicYearId: this.biddingAcademicYearId,
        statusId: status,
      };

      const { data: response } = await _updateStatus(payload);
      if (response) {
        this.ShowToast(
          'Confirmación',
          `El estatus ha sido cambiado a ${options[status][1]} exitosamente.`,
          'success'
        );
        this.isVisibleLocation = false;
        this.isVisibleLocation_DeniedPanel = false;
        await this.getSectionsProviderProfile();
        await this.onTabClick(providerQuestionSection.Location);
      } else {
        this.ShowToast('Error', response?.data?.message || 'error', 'error');
      }
    },
    async onGoBackStatusHandler(item) {
      const answer = await this.ShowCancelModal(
        'Determinación',
        `¿Está seguro(a) que desea regresar al estatus Sometido?`,
        'Sí',
        'No'
      );
      if (!answer) return;

      await _goBackStatusContractDocument(item.contractDocumentId).then(() => {
        this.ShowToast(
          `Confirmación`,
          `El estatus ha sido actualizado exitosamente.`,
          'success'
        );
      });
      await this.getContractRequiredDocuments();
    },
    async onGoBackStatusHandlerSQE(item) {
      const answer = await this.ShowCancelModal(
        'Determinación',
        `¿Está seguro(a) que desea regresar al estatus Sometido?`,
        'Sí',
        'No'
      );
      if (!answer) return;

      const payload = {
        sectionId: item.id,
        providerId: +this.companyId,
        academicYearId: this.biddingAcademicYearId,
        statusId: providerProfileStates.Submitted,
      };

      const { data: response } = await _updateStatus(payload);

      if (response) {
        this.ShowToast(
          'Confirmación',
          'El estatus ha sido actualizado exitosamente.',
          'success'
        );
        await this.getSectionsProviderProfile();
        await this.onTabClick(item.id);
      } else {
        this.ShowToast('Error', response?.data?.message || 'error', 'error');
      }
      if (this.isVisibleSQE && this.$refs.ExecutiveSummary) {
        this.$refs.ExecutiveSummary.onGoBackHandler(item);
      }
    },
    async onGoBackStatusHandlerFRB(item) {
      const answer = await this.ShowCancelModal(
        'Determinación',
        `¿Está seguro(a) que desea regresar al estatus Sometido?`,
        'Sí',
        'No'
      );
      if (!answer) return;

      const payload = {
        sectionId: item.id,
        providerId: +this.companyId,
        academicYearId: this.biddingAcademicYearId,
        statusId: providerProfileStates.Submitted,
      };

      const { data: response } = await _updateStatus(payload);

      if (response) {
        this.ShowToast(
          'Confirmación',
          'El estatus ha sido actualizado exitosamente.',
          'success'
        );
        await this.getSectionsProviderProfile();
        await this.onTabClick(item.id);
      } else {
        this.ShowToast('Error', response?.data?.message || 'error', 'error');
      }
    },
    async onActionItemDeniedHandler(item, index) {
      const deniedReasonRef = this.$refs[`deniedReasonRef-${index}`][0];
      const validator = await deniedReasonRef.validate();
      if (!validator.valid) return;

      await this.onActionItemsHandler(
        item,
        providerContractDocumentStatus.Denied
      );
    },
    async onActionItemApproveHandler(item) {
      await this.onActionItemsHandler(
        item,
        providerContractDocumentStatus.Approved
      );
    },
    onActionItemApproveCanceledHandler(item) {
      item.reason = null;
      item.approvePanel.editting = false;
    },
    onActionItemDeniedCanceledHandler(item) {
      item.reason = null;
      item.deniedPanel.editting = false;
    },
    async onActionItemReplacementRequestHandler(item, index) {
      const replacementRequestRef = this.$refs[
        `replacementRequestReasonRef-${index}`
      ][0];
      const validator = await replacementRequestRef.validate();
      if (!validator.valid) return;

      await this.onActionItemsHandler(
        item,
        providerContractDocumentStatus.ReplacementRequest
      );
    },
    onActionItemReplacementRequestCanceledHandler(item) {
      item.reason = null;
      item.replacementRequestPanel.editting = false;
    },
    async onActionItemConditionalApprovedHandler(item, index) {
      const replacementRequestRef = this.$refs[
        `conditionalApprovedReasonRef-${index}`
      ][0];
      const replacementEndDateRef = this.$refs[
        `conditionalApprovedEndDateRef-${index}`
      ][0];
      const validatorRequest = await replacementRequestRef.validate();
      const validatorEndDate = await replacementEndDateRef.validate();
      if (!validatorRequest.valid || !validatorEndDate.valid) return;

      await this.onActionItemsHandler(
        item,
        providerContractDocumentStatus.ConditionalApproved
      );
    },
    async onSaveES_Panel(statusId) {
      try {
        if (providerProfileStates.Denied == statusId) {
          const isValid = await this.$refs.messageObserver_sectionInfoES.validate();
          if (!isValid) {
            this.ShowToast(
              'Alerta',
              'Favor especificar la Razón de Rechazo.',
              'error'
            );
            return;
          }
        }

        const payload = {
          sectionId: providerQuestionSection.ExecutiveSummary,
          providerId: +this.companyId,
          academicYearId: this.biddingAcademicYearId,
          statusId: statusId,
          denialComment: this.sectionInfoES.denialComment,
        };
        const { data: response } = await _updateStatus(payload);
        if (response) {
          this.ShowToast(
            'Confirmación',
            'El estatus ha sido actualizado exitosamente.',
            'success'
          );
          this.onToggleCallOutES();
          this.getSectionsProviderProfile();
          await this.onTabClick(providerQuestionSection.ExecutiveSummary);
          this.onCancelES_Panel();
        } else {
          this.ShowToast('Error', response?.data?.message || 'error', 'error');
        }
      } catch (err) {
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error');
      }
    },
    async onSaveSQE_DeniedPanel() {
      try {
        const isValid = await this.$refs.messageObserver_sectionInfoSQE.validate();
        if (!isValid) {
          this.ShowToast(
            'Alerta',
            'Favor especificar la Razón de Rechazo.',
            'error'
          );
          return;
        }
        const payload = {
          sectionId: providerQuestionSection.SupervisionQualityEthicalSection,
          providerId: +this.companyId,
          academicYearId: this.biddingAcademicYearId,
          statusId: providerProfileStates.Denied,
          denialComment: this.sectionInfoSQE.denialComment,
        };
        const { data: response } = await _updateStatus(payload);
        if (response) {
          this.ShowToast(
            'Confirmación',
            'El estatus ha sido actualizado exitosamente.',
            'success'
          );
          this.onToggleCallOutSQE();
          this.getSectionsProviderProfile(
            providerQuestionSection.SupervisionQualityEthicalSection
          );
          await this.onTabClick(payload.sectionId);
        } else {
          this.ShowToast('Error', response?.data?.message || 'error', 'error');
        }
      } catch (err) {
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error');
      }
    },
    async onSaveFRB_Panel(statusId) {
      try {
        if (statusId == providerProfileStates.Denied) {
          const isValid = await this.$refs.messageObserver_sectionInfoFRB.validate();
          if (!isValid) {
            this.ShowToast(
              'Alerta',
              'Favor especificar la Razón de Rechazo.',
              'error'
            );
            return;
          }
        }
        const payload = {
          sectionId: providerQuestionSection.FinancialResourcesBilling,
          providerId: +this.companyId,
          academicYearId: this.biddingAcademicYearId,
          statusId: statusId,
          denialComment: this.sectionInfoFRB.denialComment,
        };
        const { data: response } = await _updateStatus(payload);
        if (response) {
          this.ShowToast(
            'Confirmación',
            'El estatus ha sido actualizado exitosamente.',
            'success'
          );
          this.onToggleCallOutFRB();
          this.getSectionsProviderProfile();
          await this.onTabClick(
            providerQuestionSection.FinancialResourcesBilling
          );
          this.onCancelFRB_Panel();
        } else {
          this.ShowToast('Error', response?.data?.message || 'error', 'error');
        }
      } catch (err) {
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error');
      }
    },
    async onSavePO_Panel(statusId) {
      try {
        if (statusId == providerProfileStates.Denied) {
          const isValid = await this.$refs.messageObserver_sectionInfoPO.validate();
          if (!isValid) {
            this.ShowToast(
              'Alerta',
              'Favor especificar la Razón de Rechazo.',
              'error'
            );
            return;
          }
        }
        const payload = {
          sectionId: providerQuestionSection.PublicOfficialsSection,
          providerId: +this.companyId,
          academicYearId: this.biddingAcademicYearId,
          statusId: statusId,
          denialComment: this.sectionInfoPO.denialComment,
        };
        const { data: response } = await _updateStatus(payload);
        if (response) {
          this.ShowToast(
            'Confirmación',
            'El estatus ha sido actualizado exitosamente.',
            'success'
          );
          this.onToggleCallOutPO();
          this.getSectionsProviderProfile();
          await this.onTabClick(providerQuestionSection.PublicOfficialsSection);
          this.onCancelPO_Panel();
        } else {
          this.ShowToast('Error', response?.data?.message || 'error', 'error');
        }
      } catch (err) {
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error');
      }
    },
    async onSaveGA_Panel(statusId) {
      try {
        if (statusId == providerProfileStates.Denied) {
          const isValid = await this.$refs.messageObserver_sectionInfoGA.validate();
          if (!isValid) {
            this.ShowToast(
              'Alerta',
              'Favor especificar la Razón de Rechazo.',
              'error'
            );
            return;
          }
        }
        const payload = {
          sectionId: providerQuestionSection.GeographicAreas,
          providerId: +this.companyId,
          academicYearId: this.biddingAcademicYearId,
          statusId: statusId,
          denialComment: this.sectionInfoGA.denialComment,
        };
        const { data: response } = await _updateStatus(payload);
        if (response) {
          this.ShowToast(
            'Confirmación',
            'El estatus ha sido actualizado exitosamente.',
            'success'
          );
          this.onToggleCallOutGA();
          this.getSectionsProviderProfile();
          await this.onTabClick(providerQuestionSection.GeographicAreas);
          this.onCancelGA_Panel();
        } else {
          this.ShowToast('Error', response?.data?.message || 'error', 'error');
        }
      } catch (err) {
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error');
      }
    },
    async onSaveLocation_Panel(statusId) {
      try {
        if (statusId == providerProfileStates.Denied) {
          const isValid = await this.$refs.messageObserver_sectionInfoLocation.validate();
          if (!isValid) {
            this.ShowToast(
              'Alerta',
              'Favor especificar la Razón de Rechazo.',
              'error'
            );
            return;
          }
        }
        const payload = {
          sectionId: providerQuestionSection.Location,
          providerId: +this.companyId,
          academicYearId: this.biddingAcademicYearId,
          statusId: statusId,
          denialComment: this.sectionInfoLocation.denialComment,
        };
        const { data: response } = await _updateStatus(payload);
        if (response) {
          this.ShowToast(
            'Confirmación',
            'El estatus ha sido actualizado exitosamente.',
            'success'
          );
          this.onToggleCallOutLocation();
          this.getSectionsProviderProfile();
          await this.onTabClick(providerQuestionSection.Location);
          this.onCancelLocation_Panel();
        } else {
          this.ShowToast('Error', response?.data?.message || 'error', 'error');
        }
      } catch (err) {
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error');
      }
    },
    async onSaveOS_Panel(statusId) {
      try {
        if (statusId == providerProfileStates.Denied) {
          const isValid = await this.$refs.messageObserver_sectionInfoOS.validate();
          if (!isValid) {
            this.ShowToast(
              'Alerta',
              'Favor especificar la Razón de Rechazo.',
              'error'
            );
            return;
          }
        }
        const payload = {
          sectionId: providerQuestionSection.ServicesToOffer,
          providerId: +this.companyId,
          academicYearId: this.biddingAcademicYearId,
          statusId: statusId,
          denialComment: this.sectionInfoOS.denialComment,
        };
        const { data: response } = await _updateStatus(payload);
        if (response) {
          this.ShowToast(
            'Confirmación',
            'El estatus ha sido actualizado exitosamente.',
            'success'
          );
          this.onToggleCallOutOS();
          this.getSectionsProviderProfile();
          await this.onTabClick(providerQuestionSection.ServicesToOffer);
          this.onCancelOS_Panel();
        } else {
          this.ShowToast('Error', response?.data?.message || 'error', 'error');
        }
      } catch (err) {
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error');
      }
    },
    async isValidLocationPanel(statusId) {
      if (statusId == providerProfileStates.ConditionalApproved)
        return await this.$refs.messageObserver_conditionalApprovePanelLocation.validate();
      else if (statusId == providerProfileStates.ReplacementRequest)
        return (
          await this.$refs.replacementRequestReasonRef_Location.validate()
        ).valid;
      else return false;
    },
    async onSaveLocation_GenericPanel(statusId) {
      try {
        const isValid = await this.isValidLocationPanel(statusId);
        if (!isValid) {
          return;
        }
        const payload = {
          sectionId: providerQuestionSection.Location,
          providerId: +this.companyId,
          academicYearId: this.biddingAcademicYearId,
          statusId: statusId,
          statusComment: this.sectionInfoLocation.statusComment,
        };

        if (statusId == providerProfileStates.ConditionalApproved)
          payload.statusEndDate = this.sectionInfoLocation.statusEndDate;

        if (statusId == providerProfileStates.ReplacementRequest)
          payload.statusComment = this.sectionInfoLocation.replacementComment;

        const { data: response } = await _updateStatus(payload);
        if (response) {
          this.ShowToast(
            'Confirmación',
            'El estatus ha sido actualizado exitosamente.',
            'success'
          );
          this.onToggleCallOutLocation();
          this.getSectionsProviderProfile();
          await this.onTabClick(providerQuestionSection.Location);
        } else {
          this.ShowToast('Error', response?.data?.message || 'error', 'error');
        }
      } catch (err) {
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error');
      }
    },
    async onGoEditHandlerES() {
      this.onToggleCallOutES();
    },
    async onGoEditHandlerSQE() {
      this.onToggleCallOutSQE();
    },
    async onGoEditHandlerFRB() {
      this.onToggleCallOutFRB();
    },
    async onGoEditHandlerGA() {
      this.onToggleCallOutGA();
    },
    async onGoEditHandlerLocation() {
      this.onToggleCallOutLocation();
    },
    async onGoEditHandlerOS() {
      this.onToggleCallOutOS();
    },
    async onGoEditHandlerPO() {
      this.onToggleCallOutPO();
    },
    onActionItemConditionalApprovedCanceledHandler(item) {
      item.reason = null;
      item.documentEndDate = null;
      item.conditionalApprovedPanel.editting = false;
    },
    onShowDeniedDocumentPanelHandler(item) {
      this.activeIndex = null;
      item.deniedPanel.editting = !item.deniedPanel.editting;
      item.conditionalApprovedPanel.editting = false;
      item.approvePanel.editting = false;
      if (item.deniedPanel.editting) {
        item.reason = '';
      }
    },
    onShowApproveDocumentPanelHandler(item) {
      this.activeIndex = null;
      item.approvePanel.editting = !item.approvePanel.editting;
      if (item.approvePanel.editting) {
        item.reason = '';
      }
      item.conditionalApprovedPanel.editting = false;
      item.replacementRequestPanel.editting = false;
      item.deniedPanel.editting = false;
    },
    onShowDeniedPanelHandlerES() {
      this.isVisibleES = false;
      this.isVisibleES_ApprovePanel = false;
      this.isVisibleES_DeniedPanel = true;
    },
    onShowApprovePanelHandlerES() {
      this.isVisibleES = false;
      this.isVisibleES_DeniedPanel = false;
      this.isVisibleES_ApprovePanel = true;
    },
    onShowDeniedPanelHandlerSQE() {
      this.isVisibleSQE = false;
      this.isVisibleSQE_ApprovePanel = false;
      this.isVisibleSQE_DeniedPanel = true;
    },
    onShowApprovePanelHandlerSQE() {
      this.isVisibleSQE = false;
      this.isVisibleSQE_DeniedPanel = false;
      this.isVisibleSQE_ApprovePanel = true;
    },
    onShowDeniedPanelHandlerFRB() {
      this.isVisibleFRB = false;
      this.isVisibleFRB_ApprovePanel = false;
      this.isVisibleFRB_DeniedPanel = true;
    },
    onShowApprovePanelHandlerFRB() {
      this.isVisibleFRB = false;
      this.isVisibleFRB_DeniedPanel = false;
      this.isVisibleFRB_ApprovePanel = true;
    },
    onShowDeniedPanelHandlerGA() {
      this.isVisibleGA = false;
      this.isVisibleGA_ApprovePanel = false;
      this.isVisibleGA_DeniedPanel = true;
    },
    onShowApprovePanelHandlerGA() {
      this.isVisibleGA = false;
      this.isVisibleGA_DeniedPanel = false;
      this.isVisibleGA_ApprovePanel = true;
    },
    onShowDeniedPanelHandlerPO() {
      this.isVisiblePO = false;
      this.isVisiblePO_ApprovePanel = false;
      this.isVisiblePO_DeniedPanel = true;
    },
    onShowApprovePanelHandlerPO() {
      this.isVisiblePO = false;
      this.isVisiblePO_DeniedPanel = false;
      this.isVisiblePO_ApprovePanel = true;
    },
    onShowApprovePanelHandlerLocation() {
      this.isVisibleLocation = false;
      this.isVisibleLocation_ReplacementPanel = false;
      this.isVisibleLocation_ConditionalApprovePanel = false;
      this.isVisibleLocation_DeniedPanel = false;
      this.isVisibleLocation_ApprovePanel = true;
    },
    onShowDeniedPanelHandlerLocation() {
      this.isVisibleLocation = false;
      this.isVisibleLocation_ReplacementPanel = false;
      this.isVisibleLocation_ConditionalApprovePanel = false;
      this.isVisibleLocation_ApprovePanel = false;
      this.isVisibleLocation_DeniedPanel = true;
    },
    onShowConditionalApproveHandlerLocation() {
      this.isVisibleLocation = false;
      this.isVisibleLocation_DeniedPanel = false;
      this.isVisibleLocation_ReplacementPanel = false;
      this.isVisibleLocation_ApprovePanel = false;
      this.isVisibleLocation_ConditionalApprovePanel = true;
    },
    onShowReplacementRequestHandlerLocation() {
      this.isVisibleLocation = false;
      this.isVisibleLocation_ConditionalApprovePanel = false;
      this.isVisibleLocation_DeniedPanel = false;
      this.isVisibleLocation_ApprovePanel = false;
      this.isVisibleLocation_ReplacementPanel = true;
    },
    onShowDeniedPanelHandlerOS() {
      this.isVisibleOS = false;
      this.isVisibleOS_ApprovePanel = false;
      this.isVisibleOS_DeniedPanel = true;
    },
    onShowApprovePanelHandlerOS() {
      this.isVisibleOS = false;
      this.isVisibleOS_DeniedPanel = false;
      this.isVisibleOS_ApprovePanel = true;
    },
    onShowReplacementRequestHandler(item) {
      this.activeIndex = null;
      item.deniedPanel.editting = false;
      item.conditionalApprovedPanel.editting = false;
      item.replacementRequestPanel.editting = !item.replacementRequestPanel
        .editting;
      if (item.replacementRequestPanel.editting) {
        item.reason = '';
      }
    },
    onShowConditionalApproveHandler(item) {
      this.activeIndex = null;
      item.deniedPanel.editting = false;
      item.conditionalApprovedPanel.editting = !item.conditionalApprovedPanel
        .editting;
      item.replacementRequestPanel.editting = false;
    },
    onToggleCallout(item, index) {
      item.deniedPanel.editting = false;
      item.conditionalApprovedPanel.editting = false;
      item.replacementRequestPanel.editting = false;
      this.activeIndex =
        this.activeIndex === null
          ? index
          : this.activeIndex === index
          ? null
          : index;
    },
    onToggleCallOutES(statusId) {
      if (this.isDeniedSQE(statusId)) {
        this.isVisibleES = false;
        this.isVisibleES_DeniedPanel = !this.isVisibleES_DeniedPanel;
      } else {
        if (this.isVisibleES_DeniedPanel == true && this.isVisibleES == false) {
          this.isVisibleES = false;
          this.isVisibleES_DeniedPanel = false;
        } else {
          this.isVisibleES = !this.isVisibleES;
        }
      }
    },
    onToggleCallOutFRB(statusId) {
      if (this.isDeniedSQE(statusId)) {
        this.isVisibleFRB = false;
        this.isVisibleFRB_DeniedPanel = !this.isVisibleFRB_DeniedPanel;
      } else {
        if (
          this.isVisibleFRB_DeniedPanel == true &&
          this.isVisibleFRB == false
        ) {
          this.isVisibleFRB = false;
          this.isVisibleFRB_DeniedPanel = false;
        } else {
          this.isVisibleFRB = !this.isVisibleFRB;
        }
      }
    },
    onToggleCallOutGA(statusId) {
      if (this.isDeniedSQE(statusId)) {
        this.isVisibleGA = false;
        this.isVisibleGA_DeniedPanel = !this.isVisibleGA_DeniedPanel;
      } else {
        if (this.isVisibleGA_DeniedPanel == true && this.isVisibleGA == false) {
          this.isVisibleGA = false;
          this.isVisibleGA_DeniedPanel = false;
        } else {
          this.isVisibleGA = !this.isVisibleGA;
        }
      }
    },
    onCancelES_Panel() {
      this.isVisibleES_DeniedPanel = this.isVisibleES_ApprovePanel = false;
      this.isVisibleES = false;
      this.sectionInfoES.denialComment = null;
    },
    onCancelSQE_DeniedPanel() {
      this.isVisibleSQE_DeniedPanel = !this.isVisibleSQE_DeniedPanel;
      this.isVisibleSQE = false;
      this.sectionInfoSQE.denialComment = null;
    },
    onCancelFRB_Panel() {
      this.isVisibleFRB_DeniedPanel = this.isVisibleFRB_ApprovePanel = false;
      this.isVisibleFRB = false;
      this.sectionInfoFRB.denialComment = null;
    },
    onCancelLocation_Panel() {
      this.isVisibleLocation_DeniedPanel = this.isVisibleLocation_ApprovePanel = false;
      this.isVisibleLocation = false;
      this.sectionInfoLocation.denialComment = null;
    },
    onCancelLocation_ConditionalApprovedPanel() {
      this.isVisibleLocation_DeniedPanel = false;
      this.isVisibleLocation = false;
      this.isVisibleLocation_ConditionalApprovePanel = !this
        .isVisibleLocation_ConditionalApprovePanel;
      this.sectionInfoLocation.statusComment = null;
      this.sectionInfoLocation.statusEndDate = null;
    },
    onCancelLocation_ReplacementPanel() {
      this.isVisibleLocation = false;
      this.sectionInfoLocation.replacementComment = null;
      this.isVisibleLocation_ReplacementPanel = false;
    },
    onCancelPO_Panel() {
      this.isVisiblePO_DeniedPanel = this.isVisiblePO_ApprovePanel = false;
      this.isVisiblePO = false;
      this.sectionInfoPO.denialComment = null;
    },
    onCancelGA_Panel() {
      this.isVisibleGA_DeniedPanel = this.isVisibleGA_ApprovePanel = false;
      this.isVisibleGA = false;
      this.sectionInfoGA.denialComment = null;
    },
    onCancelOS_Panel() {
      this.isVisibleOS_DeniedPanel = this.isVisibleOS_ApprovePanel = false;
      this.isVisibleOS = false;
      this.sectionInfoOS.denialComment = null;
    },
    onToggleCallOutLocation(statusId) {
      if (this.isDeniedSQE(statusId)) {
        this.isVisibleLocation = false;
        this.isVisibleLocation_ConditionalApprovePanel = false;
        this.isVisibleLocation_ReplacementPanel = false;
        this.isVisibleLocation_DeniedPanel = !this
          .isVisibleLocation_DeniedPanel;
      } else if (this.isConditionalApprovedSQE(statusId)) {
        this.isVisibleLocation = false;
        this.isVisibleLocation_DeniedPanel = false;
        this.isVisibleLocation_ReplacementPanel = false;
        this.isVisibleLocation_ConditionalApprovePanel = !this
          .isVisibleLocation_ConditionalApprovePanel;
      } else if (this.isReplacementRequestSQE(statusId)) {
        this.isVisibleLocation = false;
        this.isVisibleLocation_DeniedPanel = false;
        this.isVisibleLocation_ConditionalApprovePanel = false;
        this.isVisibleLocation_ReplacementPanel = !this
          .isVisibleLocation_ReplacementPanel;
      } else {
        if (this.isVisibleLocation_DeniedPanel && !this.isVisibleLocation) {
          this.isVisibleLocation = false;
          this.isVisibleLocation_DeniedPanel = false;
        } else if (
          this.isVisibleLocation_ConditionalApprovePanel &&
          !this.isVisibleLocation
        ) {
          this.isVisibleLocation = false;
          this.isVisibleLocation_ConditionalApprovePanel = false;
        } else if (
          this.isVisibleLocation_ReplacementPanel &&
          !this.isVisibleLocation
        ) {
          this.isVisibleLocation = false;
          this.isVisibleLocation_ReplacementPanel = false;
        } else {
          this.isVisibleLocation = !this.isVisibleLocation;
        }
      }
    },
    onToggleCallOutOS(statusId) {
      if (this.isDeniedSQE(statusId)) {
        this.isVisibleOS = false;
        this.isVisibleOS_DeniedPanel = !this.isVisibleOS_DeniedPanel;
      } else {
        if (this.isVisibleOS_DeniedPanel && !this.isVisibleOS) {
          this.isVisibleOS = false;
          this.isVisibleOS_DeniedPanel = false;
        } else {
          this.isVisibleOS = !this.isVisibleOS;
        }
      }
    },
    onToggleCallOutSQE(statusId) {
      if (this.isDeniedSQE(statusId)) {
        this.isVisibleSQE = false;
        this.isVisibleSQE_DeniedPanel = !this.isVisibleSQE_DeniedPanel;
      } else {
        if (
          this.isVisibleSQE_DeniedPanel == true &&
          this.isVisibleSQE == false
        ) {
          this.isVisibleSQE = false;
          this.isVisibleSQE_DeniedPanel = false;
        } else {
          this.isVisibleSQE = !this.isVisibleSQE;
        }
      }
    },
    onToggleCallOutPO(statusId) {
      if (this.isDeniedSQE(statusId)) {
        this.isVisiblePO = false;
        this.isVisiblePO_DeniedPanel = !this.isVisiblePO_DeniedPanel;
      } else {
        if (this.isVisiblePO_DeniedPanel == true && this.isVisiblePO == false) {
          this.isVisiblePO = false;
          this.isVisiblePO_DeniedPanel = false;
        } else {
          this.isVisiblePO = !this.isVisiblePO;
        }
      }
    },
    async onChangeDocumentExpirationDateHandler(
      { contractDocumentId },
      dateValue
    ) {
      if (contractDocumentId) {
        await _updateDocumentExpirationDate(contractDocumentId, dateValue);
      }
    },
    async onChangeDocumentAppointmentDateHandler(
      { contractDocumentId },
      dateValue
    ) {
      if (contractDocumentId) {
        await _updateDocumentAppointmentDate(contractDocumentId, dateValue);
      }
    },
    async onChangeClassificationTypeHandler(item, value) {
      if (item.contractDocumentId) {
        await _updateDocumentClassificationType(
          item.contractDocumentId,
          value?.id
        );
        item.documentExpirationDate = null;
        item.documentAppointmentDate = null;
      }
    },
    async onChangeLicenseSpecialtyTypeHandler({ contractDocumentId }, value) {
      if (contractDocumentId) {
        await _updateDocumentLicenseSpecialtyType(
          contractDocumentId,
          value?.id
        );
      }
    },
    async updateApplicableFlag(item, isExempted) {
      if (!this.isDeniedDocument(item)) {
        item.groupType = isExempted
          ? groupTypes.additional
          : groupTypes.required;
        const payload = {
          contractDocumentId: item.contractDocumentId,
          isExempted,
          companyId: +this.companyId,
          academicYearId: this.biddingAcademicYearId,
          contractDocumentTypeId: item.contractDocumentTypeId,
        };
        await _updateDocumentExemptionFlag(payload);
        if (item.contractDocumentId && !isExempted) {
          await this.onRemoveHandler(item);
        } else {
          await this.getContractRequiredDocuments();
        }
      }
    },
    navigateBack() {
      // Use the previous route to navigate back
      if (this.previousRoute) {
        this.$router.push({
          name: this.previousRoute.name,
          params: { currentPage: this.$route.params?.currentPage },
        });
      } else {
        // If no previous route is available, you can go back using $router.go
        this.$router.go(-1);
      }
    },
    async getSectionsProviderProfile() {
      this.sectionsProviderProfile = (
        await _getSections(this.companyId, this.biddingAcademicYearId)
      ).data;

      this.sectionInfoSQE = this.sectionsProviderProfile.find(
        (x) => x.id === providerQuestionSection.SupervisionQualityEthicalSection
      );
      this.sectionInfoES = this.sectionsProviderProfile.find(
        (x) => x.id === providerQuestionSection.ExecutiveSummary
      );
      this.sectionInfoLocation = this.sectionsProviderProfile.find(
        (x) => x.id === providerQuestionSection.Location
      );
      this.sectionInfoFRB = this.sectionsProviderProfile.find(
        (x) => x.id === providerQuestionSection.FinancialResourcesBilling
      );
      this.sectionInfoPO = this.sectionsProviderProfile.find(
        (x) => x.id === providerQuestionSection.PublicOfficialsSection
      );
      this.sectionInfoGA = this.sectionsProviderProfile.find(
        (x) => x.id === providerQuestionSection.GeographicAreas
      );
      this.sectionInfoOS = this.sectionsProviderProfile.find(
        (x) => x.id === providerQuestionSection.ServicesToOffer
      );

      this.getQuestionsES();
      this.getQuestionsSQE();
      this.getQuestionsFRB();
      this.getQuestionsPO();
      this.getOptionsGA();

      this.isVisibleLocation_DeniedPanel = false;
    },
    async getQuestionsSQE() {
      const { data: response } = await _getQuestions(
        providerQuestionSection.SupervisionQualityEthicalSection,
        this.providerInfo?.companyId
      );
      this.questionsSQE = response;
    },
    async getQuestionsPO() {
      const { data: response } = await _getQuestions(
        providerQuestionSection.PublicOfficialsSection,
        this.providerInfo?.companyId
      );
      this.questionsPO = response;
    },
    async getQuestionsES() {
      const { data: response } = await _getQuestions(
        providerQuestionSection.ExecutiveSummary,
        this.providerInfo?.companyId
      );
      this.questionsES = response;
    },
    async getQuestionsFRB() {
      const { data: response } = await _getQuestions(
        providerQuestionSection.FinancialResourcesBilling,
        this.providerInfo?.companyId
      );
      this.questionsFRB = response;
    },
    async getOptionsGA() {
      this.optionsGA = [];
      const { data: response } = await _getMunicipalities(
        this.providerInfo?.companyId,
        this.academicYearId
      );
      this.optionsGA = response;
    },
    async getProviderProfileSysParameter() {
      const { data } = await getByParameterName(
        'RPProviderProfileEnabled',
        this.academicYearId
      );
      if (data) {
        this.providerProfileEnabled =
          data.value === 'true' &&
          this.providerInfo.providerTypeId != providerTypes.Asistente &&
          !this.providerInfo.isServiceAssistant;
      }
    },
    async getUniquePermissionInProviderRequestDocumentsParameter() {
      const { data } = await getByParameterName(
        'RP_UniquePermissionInProviderRequestDocuments',
        this.academicYearId
      );
      this.isUniquePermissionInProviderRequestDocumentsEnabled =
        data?.value?.toLowerCase() === 'true';
    },
    onTabClick(sectionId) {
      const payload = {
        sectionId: sectionId,
        providerId: this.companyId,
        academicYearId: this.biddingAcademicYearId,
      };

      this.getSectionStatusHistory(payload);
    },
    async getSectionStatusHistory(payload) {
      const key = this.reverseSectionMap[payload.sectionId];

      const { data: response } = await _getSectionStatusHistory(payload);
      this.sectionStatusHistoryMap[key] = response;
    },
    async onLockHandler() {
      try {
        const { data } = await _lockProvider(
          this.academicYearId,
          this.companyId
        );
        if (!data.success) {
          this.ShowToast('Aviso', data.message, 'warning');
          return;
        }
        await this.getCompanyHeaderInfo(this.academicYearId);
        this.ShowToast('Éxito', 'Proveedor bloqueado exitosamente.', 'success');
      } catch {
        this.ShowToast('Error', 'Error al bloquear el proveedor.', 'error');
      }
    },
    async onUnlockHandler() {
      try {
        const { data } = await _unlockProvider(
          this.academicYearId,
          this.companyId
        );
        if (!data.success) {
          this.ShowToast('Aviso', data.message, 'warning');
          return;
        }
        await this.getCompanyHeaderInfo(this.academicYearId);
        this.ShowToast(
          'Éxito',
          'Proveedor desbloqueado exitosamente.',
          'success'
        );
      } catch {
        this.ShowToast('Error', 'Error al desbloquear el proveedor.', 'error');
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.previousRoute = from;
    });
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';

.expiring-locations-alert {
  margin-top: 4px;
  padding-top: 10px;
  padding-bottom: 10px;
  color: #af6708;
  font-family: 'Lato', sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 115%;
  letter-spacing: -0.08px;
  border: 2px solid #af6708 !important;

  &__title {
    font-weight: 700;
  }

  &__item {
    margin-top: 10px;
  }

  &__date {
    font-weight: 700;
  }
}

.btn-action-size {
  width: 35px;
  height: 35px;
}
.file-input__extended ::v-deep {
  .file-input-container {
    width: 35px;
    height: 35px !important;
    border-color: map-get($colors, 'green');
    em {
      font-size: 18px;
      margin-left: -2px;
    }
    .file-select {
      span {
        display: none;
      }
    }
  }
}
.dropdown-custom-action ::v-deep {
  .dropdown {
    button {
      padding: 5px 15px 5px 15px;
    }
  }
}
.divider {
  border-left: solid map-get($colors, 'secondary-5') 2px;
}
.text-gray-16 {
  color: map-get($colors, 'gray-16');
}
::v-deep .custom-icon {
  .dot {
    box-shadow: none !important;
    margin-right: 4px !important;
  }
  .dot.dot--has-border {
    border-color: transparent !important;
  }
  .color-gray-7.font-16.font-weight-bold {
    color: #11291b !important;
  }
}

.color-brown {
  color: #af6708 !important;
}
.border-brown {
  border-color: #af6708 !important;
}
</style>
